webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var configData =  false ? require('./data-dev.json') : __webpack_require__(352);

var getConfigData = function getConfigData() {
  return configData;
};

/* harmony default export */ __webpack_exports__["a"] = (getConfigData);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return newSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadResultsWithDataPreload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadResultsWithDataPreloadAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadDateRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetSearchQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_autocompleteStore_setters__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_filters_setters__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_date_filters_setters__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(3);








var loadResults = function loadResults() {
  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["b" /* loadSearchResults */]();
};

var loadResultsWithDataPreload = function loadResultsWithDataPreload() {
  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["c" /* loadSearchResultsWithDataPreload */]();
};

var loadResultsWithDataPreloadAlt = function loadResultsWithDataPreloadAlt() {
  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["d" /* loadSearchResultsWithDataPreloadAlt */]();
};

var newSearchQuery = function newSearchQuery(params) {
  __WEBPACK_IMPORTED_MODULE_2__store_autocompleteStore_setters__["a" /* setIsActiveAutocompleteDropdown */](true);

  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["e" /* setSearchParams */](params);
  resetPageParams();

  loadResultsWithDataPreload();
};

var resetSearchQuery = function resetSearchQuery() {
  resetPageParams();

  loadResultsWithDataPreload();
};

var resetPageParams = function resetPageParams() {
  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["f" /* resetRows */]();

  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["g" /* resetPageStart */]();

  if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().key == __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */])().params.search.default.key) {
    __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["a" /* setNewSorting */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */])().params.search.default.sortOptionAll);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["h" /* resetSorting */]();
  }

  __WEBPACK_IMPORTED_MODULE_3__store_filters_setters__["a" /* resetFilterParams */]();

  __WEBPACK_IMPORTED_MODULE_4__store_date_filters_setters__["b" /* resetDateRange */]();
};

var loadDateRanges = function loadDateRanges() {
  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["i" /* loadDateRanges */]();
};



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_search__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_autocomplete__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_app__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_filters__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_date_filters__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_date_filters__ = __webpack_require__(264);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_7__modules_app__,
    search: __WEBPACK_IMPORTED_MODULE_5__modules_search__,
    autocomplete: __WEBPACK_IMPORTED_MODULE_6__modules_autocomplete__,
    filters: __WEBPACK_IMPORTED_MODULE_8__modules_filters__,
    dateFilters: __WEBPACK_IMPORTED_MODULE_9__modules_date_filters__
  },
  plugins: [__WEBPACK_IMPORTED_MODULE_10__plugins_date_filters__["a" /* default */]],
  strict: "production" !== 'production'
}));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetPageStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetSorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setPageStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setRowsNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setNewSorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setCurrentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSearchParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setNewSearchParamsKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setNewSearchParamsParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadSearchResultsWithDataPreload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadSearchResultsWithDataPreloadAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadDateRanges; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




var dataSearchDefault = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])().params.search.default;

var resetPageStart = function resetPageStart() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_START', dataSearchDefault.pageStart);
};

var resetRows = function resetRows() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_ROWS_NUM', dataSearchDefault.itemsPerPage);
};

var resetSorting = function resetSorting() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_SORTING', dataSearchDefault.sortOption);
};

var setPageStart = function setPageStart(n) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_START', n);
};

var setRowsNum = function setRowsNum(n) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_ROWS_NUM', n);
};

var setNewSorting = function setNewSorting(n) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_SORTING', n);
};

var setCurrentPage = function setCurrentPage(n) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_CURRENT_PAGE', n);
};

var setSearchParams = function setSearchParams(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_SEARCH_PARAMS', params);
};

var setNewSearchParamsKey = function setNewSearchParamsKey(key) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_SEARCH_PARAMS_KEY', key);
};

var setNewSearchParamsParam = function setNewSearchParamsParam(param) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_NEW_SEARCH_PARAMS_PARAM', param);
};

var loadSearchResults = function loadSearchResults() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('LOAD_SEARCH_RESULTS');
};

var loadSearchResultsWithDataPreload = function loadSearchResultsWithDataPreload() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD');
};

var loadSearchResultsWithDataPreloadAlt = function loadSearchResultsWithDataPreloadAlt() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD_ALT');
};

var loadDateRanges = function loadDateRanges() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('LOAD_DATE_RANGES');
};



/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDateFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDateTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDateStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDateEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIsDate; });
/* unused harmony export getIsDateValid */
/* unused harmony export getIsPreviousDateValid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDateGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDateFromStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDateToStatic; });
/* unused harmony export getDateFromActive */
/* unused harmony export getDateToActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var getDateFrom = function getDateFrom() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_FROM;
};

var getDateTo = function getDateTo() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_TO;
};

var getDateFromStatic = function getDateFromStatic() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_FROM_STATIC;
};

var getDateToStatic = function getDateToStatic() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_TO_STATIC;
};

var getDateFromActive = function getDateFromActive() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_FROM_ACTIVE;
};

var getDateToActive = function getDateToActive() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_TO_ACTIVE;
};

var getDateStart = function getDateStart() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_START;
};

var getDateEnd = function getDateEnd() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_END;
};

var getIsDate = function getIsDate() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_IS_DATE_SET;
};

var getIsDateValid = function getIsDateValid() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_IS_DATE_VALID;
};

var getIsPreviousDateValid = function getIsPreviousDateValid() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_IS_PREVIOUS_DATE_VALID;
};

var getDateGap = function getDateGap() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_DATE_GAP;
};



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setDateFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setDateTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDateRangeFromRes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setDateGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setDateFromStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setDateToStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setDateFromActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setDateToActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setToDateArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setValidDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setCheckDate; });
/* unused harmony export popFromDateArr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return resetDateArr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var setDateFrom = function setDateFrom(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_FROM', params);
};

var setDateTo = function setDateTo(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_TO', params);
};

var setDateFromStatic = function setDateFromStatic(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_FROM_STATIC', params);
};

var setDateToStatic = function setDateToStatic(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_TO_STATIC', params);
};

var setDateFromActive = function setDateFromActive(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_FROM_ACTIVE', params);
};

var setDateToActive = function setDateToActive(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_TO_ACTIVE', params);
};

var setDateRangeFromRes = function setDateRangeFromRes(data) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_RANGE_RES', data);
};

var resetDateRange = function resetDateRange() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('RESET_DATE_RANGE');
};

var setValidDate = function setValidDate(position, value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_VALID_DATE_' + position, value);
};

var setCheckDate = function setCheckDate(value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_CHECK_DATE', value);
};

var setDateGap = function setDateGap(data) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_DATE_GAP', data);
};

var setToDateArr = function setToDateArr(obj) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_TO_DATE_ARR', obj);
};

var popFromDateArr = function popFromDateArr() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('POP_FROM_DATE_ARR');
};

var resetDateArr = function resetDateArr() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('RESET_DATE_ARR');
};



/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatDate = function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear().toString().substr(-4);

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (year.length == 1) year = '000' + year;
    if (year.length == 2) year = '00' + year;
    if (year.length == 3) year = '0' + year;

    return [year, month, day].join('-');
};

/* harmony default export */ __webpack_exports__["a"] = (formatDate);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchParams; });
/* unused harmony export newSearchParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return totalPagesNum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var searchParams = function searchParams() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_SEARCH_PARAMS;
};

var newSearchParams = function newSearchParams() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_NEW_SEARCH_PARAMS;
};

var currentPage = function currentPage() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_CURRENT_PAGE;
};

var totalPagesNum = function totalPagesNum() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_TOTAL_PAGES_NUM;
};



/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilterParamsStatic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var getFilterParams = function getFilterParams() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_FILTER_PARAMS;
};

var getFilterParamsStatic = function getFilterParamsStatic() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_FILTER_PARAMS_STATIC;
};



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetFilterParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var setFilterParams = function setFilterParams(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_FILTER_PARAMS', params);
};

var resetFilterParams = function resetFilterParams() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('RESET_FILTER_PARAMS');
};



/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setDateActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setDateGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setToArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setValidDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return momentDateValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return momentDateRangeValidDateFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return momentDateRangeValidDateTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return momentCheckDateFromDateTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reusable_format_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var setDateRange = function setDateRange() {
  var dateFrom = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["a" /* getDateFrom */]();
  var dateTo = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["b" /* getDateTo */]();
  var dateStart = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["c" /* getDateStart */]();
  var dateEnd = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["d" /* getDateEnd */]();
  var dateFromStatic = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["g" /* getDateFromStatic */]();
  var dateToStatic = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["h" /* getDateToStatic */]();

  if (dateFrom == '') {
    __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["c" /* setDateFrom */](dateStart);
  }
  if (dateTo == '') {
    __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["e" /* setDateTo */](dateEnd);
  }

  setDateGap(__WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["a" /* getDateFrom */](), __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["b" /* getDateTo */]());

  __WEBPACK_IMPORTED_MODULE_2__store_searchStore_setters__["f" /* resetRows */]();

  __WEBPACK_IMPORTED_MODULE_2__store_searchStore_setters__["g" /* resetPageStart */]();

  if (dateFrom != dateFromStatic || dateTo != dateToStatic) {
    __WEBPACK_IMPORTED_MODULE_3__search__["c" /* loadResults */]();
  }
};

var resetDateRange = function resetDateRange() {
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["b" /* resetDateRange */]();

  __WEBPACK_IMPORTED_MODULE_3__search__["b" /* loadResultsWithDataPreload */]();
};

var setDateActive = function setDateActive(start, end) {
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["h" /* setDateFromActive */](start);
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["i" /* setDateToActive */](end);
};

var setDateGap = function setDateGap(start, end) {
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["g" /* setDateGap */]({
    start: start,
    end: end
  });
};

var setToArr = function setToArr(start, end) {
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["j" /* setToDateArr */]({
    start: start,
    end: end
  });
};

var isDate = function isDate(value, position, defaultDate) {
  var re = /^\d{1,4}|\.$/;

  if (re.test(value)) {
    Number.prototype.zeroPad = function (length) {
      length = length || 2;
      return (new Array(length).join('0') + this).slice(length * -1);
    };

    var date = value.split('.').reverse(),
        day = date[2] ? date[2] : '1',
        month = date[1] ? date[1] : '1',
        year = date[0].length < 4 ? ('000' + date[0]).slice(-4) : date[0],
        MOMdate = void 0,
        MOMday = void 0,
        MOMmonth = void 0,
        MOMyear = void 0;

    if (position == 'TO') {
      if (!date[1] && !date[2]) {
        day = 31;
        month = 12;
      }

      if (!date[2]) {
        var dayMOMdate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().set({ 'year': year, 'month': month, 'date': 1 });
        day = dayMOMdate.subtract(1, 'day').get('date');
      }
    }

    MOMdate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD');

    if (MOMdate.isValid()) {
      MOMday = MOMdate.get('date');
      MOMmonth = MOMdate.get('month') + 1;
      MOMyear = MOMdate.get('year');

      __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["k" /* setValidDate */](position, true);
      return MOMyear.zeroPad(4) + '-' + MOMmonth.zeroPad() + '-' + MOMday.zeroPad();
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["k" /* setValidDate */](position, false);
      return value;
    }
  } else {

    return defaultDate;
  }
};

var setValidDates = function setValidDates() {
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["k" /* setValidDate */]('FROM', true);
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["k" /* setValidDate */]('TO', true);
};

var momentDateValid = function momentDateValid(objectDate) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(objectDate, 'DD.MM.YYYY').isValid() ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(objectDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : objectDate;
};

var momentDateRangeValidDateFrom = function momentDateRangeValidDateFrom(dateStart, dateEnd, dateDefault) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateStart).isAfter(dateDefault) && __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateStart).isBefore(dateEnd) || __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateStart).isSame(dateEnd) ? dateStart : dateDefault;
};

var momentDateRangeValidDateTo = function momentDateRangeValidDateTo(dateStart, dateEnd, dateDefault) {
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateEnd).isAfter(dateStart) && __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateEnd).isBefore(dateDefault) || __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateEnd).isSame(dateStart) ? dateEnd : dateDefault;
};

var momentCheckDateFromDateTo = function momentCheckDateFromDateTo(dateStart, dateEnd) {
  var checkDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateEnd).isAfter(dateStart);
  __WEBPACK_IMPORTED_MODULE_0__store_date_filters_setters__["l" /* setCheckDate */](checkDate);

  return checkDate;
};



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_filters_setters__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_date_filters_setters__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(6);







var setFilters = function setFilters(filters, filterName) {
  __WEBPACK_IMPORTED_MODULE_0__store_filters_setters__["b" /* setFilterParams */]({
    "name": filterName,
    "filters": filters
  });

  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["f" /* resetRows */]();

  __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["g" /* resetPageStart */]();

  if (__WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["f" /* getIsDate */]()) {
    __WEBPACK_IMPORTED_MODULE_4__search__["a" /* loadResultsWithDataPreloadAlt */]();
  } else {
    __WEBPACK_IMPORTED_MODULE_4__search__["b" /* loadResultsWithDataPreload */]();
  }

  __WEBPACK_IMPORTED_MODULE_2__store_date_filters_setters__["m" /* resetDateArr */]();
};

var resetFilters = function resetFilters() {
  __WEBPACK_IMPORTED_MODULE_0__store_filters_setters__["a" /* resetFilterParams */]();
};



/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pad = function pad(number) {
  return number < 10 ? '0' + number : number;
};

var convertToIso = function convertToIso(date) {
  if (!Date.prototype.toLocalISOString) {
    Date.prototype.toLocalISOString = function () {
      return this.getFullYear() + '-' + pad(this.getMonth() + 1) + '-' + pad(this.getDate()) + 'T' + pad(this.getHours()) + ':' + pad(this.getMinutes()) + ':' + pad(this.getSeconds()) + '.' + (this.getMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
    };
  }
  return date.toLocalISOString();
};

/* harmony default export */ __webpack_exports__["a"] = (convertToIso);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLastPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setPreviousPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setActivePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isDisplayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isDisplayedEllipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateCurrentPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(6);







var isFirstPage = function isFirstPage() {
  return __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() == 1;
};

var isLastPage = function isLastPage() {
  return __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() == __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["c" /* totalPagesNum */]();
};

var setActivePage = function setActivePage(n) {
  if (__WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() != n) {
    __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["n" /* setCurrentPage */](n);
    __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["m" /* setPageStart */](n);
    __WEBPACK_IMPORTED_MODULE_3__search__["c" /* loadResults */]();
  }
};

var setPreviousPage = function setPreviousPage() {
  if (!isFirstPage()) {
    setActivePage(__WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() - 1);
  }
};

var setNextPage = function setNextPage() {
  if (!isLastPage()) {
    setActivePage(__WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() + 1);
  }
};

var isDisplayed = function isDisplayed(n) {
  return n == 1 || n > __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["c" /* totalPagesNum */]() - 2 || n > __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() - 2 && n < __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() + 2;
};

var isDisplayedEllipsis = function isDisplayedEllipsis(n) {
  return n == __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() - 2 || n == __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["b" /* currentPage */]() + 2;
};

var updateCurrentPage = function updateCurrentPage(event) {
  var newCurrentPage = parseInt(event.target.value);

  if (newCurrentPage > 0 && newCurrentPage <= __WEBPACK_IMPORTED_MODULE_2__store_searchStore_getters__["c" /* totalPagesNum */]()) {
    setActivePage(newCurrentPage);
  }
};



/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_searchStore_getters__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_reusable_format_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_modules_local_iso_string__ = __webpack_require__(57);











var dataSolr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().solr;

var facets = dataSolr.filters;

var getPath = function getPath() {
  var facetsPath = 'facet=' + facets.facet_on + '&facet.sort=' + facets.facet_sort_count + '&stats=on&stats.field=date_start&stats.field=date_end';

  facets.facet_fileds.forEach(function (value) {
    facetsPath += '&facet.field={!ex=' + value + '}' + value + '&f.' + value + '.facet.limit=' + facets.facet_limit + '&f.' + value + '.facet.mincount=' + facets.facet_mincount;
  });

  return dataSolr.paths.API + dataSolr.query.searchPre + facetsPath + getFiltersQuery() + getDateRangeQuery() + getSearchQuery() + dataSolr.query.searchPost;
};

var getDateRangeQuery = function getDateRangeQuery() {
  var dateFrom = __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["a" /* getDateFrom */]();
  var dateTo = __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["b" /* getDateTo */]();
  var dateStart = __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["c" /* getDateStart */]();
  var dateEnd = __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["d" /* getDateEnd */]();
  var dateGap = __WEBPACK_IMPORTED_MODULE_3__store_date_filters_getters__["e" /* getDateGap */]();
  var dateRangeQuery = '';

  if (dateFrom != '' && dateTo != '') {
    if (!(dateFrom == dateStart && dateTo == dateEnd)) {
      dateFrom = new Date(dateFrom);
      dateTo = new Date(dateTo);

      if (dateFrom.getTime() === dateTo.getTime()) {
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 999);
      }

      dateRangeQuery += '&facet.range=' + facets.facet_range + '&f.date.facet.range.hardend=true' + '&f.date.facet.range.start=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__scripts_modules_local_iso_string__["a" /* default */])(dateFrom) + '&f.date.facet.range.end=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__scripts_modules_local_iso_string__["a" /* default */])(dateTo) + '&f.date.facet.range.gap=%2B' + dateGap + 'DAYS' + '&fq={!tag=date}date:[' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scripts_reusable_format_date__["a" /* default */])(dateFrom) + ' TO ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scripts_reusable_format_date__["a" /* default */])(dateTo) + ']';
    } else {
      dateStart = new Date(dateStart);
      dateEnd = new Date(dateEnd);

      if (dateStart.getTime() === dateEnd.getTime()) {
        dateStart.setHours(0, 0, 0, 0);
        dateEnd.setHours(23, 59, 59, 999);
      }

      dateRangeQuery += '&facet.range=' + facets.facet_range + '&f.date.facet.range.hardend=true' + '&f.date.facet.range.start=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__scripts_modules_local_iso_string__["a" /* default */])(dateStart) + '&f.date.facet.range.end=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__scripts_modules_local_iso_string__["a" /* default */])(dateEnd) + '&f.date.facet.range.gap=%2B' + dateGap + 'DAYS';
    }
  }

  return dateRangeQuery;
};

var getFiltersQuery = function getFiltersQuery() {
  var filterParams = __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__["a" /* getFilterParams */]();
  var filtersQuery = '';

  filterParams.forEach(function (value) {
    var filterQuery = '&fq={!tag=' + value.name + '}';

    function addElem(element, index, array) {
      if (index > 0) {
        filterQuery += ' OR ' + value.name + ': \"' + element + '\"';
      } else {
        filterQuery += value.name + ': \"' + element + '\"';
      }
    }

    value.filters.forEach(addElem);

    filtersQuery += filterQuery;
  });

  return filtersQuery;
};

var getSearchQuery = function getSearchQuery() {
  var searchParams = __WEBPACK_IMPORTED_MODULE_1__store_searchStore_getters__["a" /* searchParams */]();
  var searchQuery = '&q=';

  var key = searchParams.key;
  var param = searchParams.param;
  var start = searchParams.start;
  var rows = searchParams.rows;
  var sorting = searchParams.sorting;

  if (param) {
    searchQuery += param + ":" + '(' + key + ')';
  } else {
    searchQuery += key;
  }

  searchQuery += '&rows=' + rows;

  if (sorting) {
    searchQuery += '&sort=' + sorting;
  }

  if (start != 0) {
    searchQuery += '&start=' + start;
  }

  return searchQuery;
};

/* harmony default export */ __webpack_exports__["a"] = (getPath);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setActiveMouse; });
/* unused harmony export setActiveSuggestTmp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setIsActiveSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setIsActiveAutocompleteDropdown; });
/* unused harmony export resetSuggestions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);




var loadSuggestions = function loadSuggestions(params) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('LOAD_SUGGESTIONS', params);
};

var setActiveMouse = function setActiveMouse(number) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_ACTIVE_MOUSE', number);
};

var setActiveSuggestTmp = function setActiveSuggestTmp(value) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_ACTIVE_SUGGEST_TMP', value);
};

var setIsActiveSuggestions = function setIsActiveSuggestions(b) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_IS_ACTIVE_SUGGESTIONS', b);
};

var setIsActiveAutocompleteDropdown = function setIsActiveAutocompleteDropdown(b) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN', b);
};

var resetSuggestions = function resetSuggestions() {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('RESET_SUGGESTIONS');
};



/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dispatchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_filters_setters__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__ = __webpack_require__(14);







var receiveUrl = function receiveUrl(url) {
    if (url['q']) {
        var searchParams = {
            "key": url['q']
        };
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["e" /* setSearchParams */](searchParams);
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["j" /* setNewSearchParamsKey */](url['q']);
    }

    if (url['q'] && url['dc']) {
        var _searchParams = {
            "key": url['q'],
            "param": url['dc']
        };
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["e" /* setSearchParams */](_searchParams);
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["j" /* setNewSearchParamsKey */](url['q']);
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["k" /* setNewSearchParamsParam */](url['dc']);
    }

    if (url['s']) {
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["a" /* setNewSorting */](url['s']);
    }

    if (url['ipp']) {
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["l" /* setRowsNum */](url['ipp']);
    }

    if (url['p']) {
        __WEBPACK_IMPORTED_MODULE_1__store_searchStore_setters__["m" /* setPageStart */](url['p']);
    }

    if (url['fq']) {
        var filtersQuery = void 0;

        filtersQuery = url['fq'].split("|");
        filtersQuery.forEach(function (el, index) {
            var value = el.split(':');
            var fquery = {};

            fquery['name'] = value[0];
            fquery['filters'] = value[1].split(',');

            __WEBPACK_IMPORTED_MODULE_3__store_filters_setters__["b" /* setFilterParams */](fquery);
        });
    }

    if (url['dr']) {
        var dateRange = void 0;
        dateRange = url['dr'].split("|");
        __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__["c" /* setDateFrom */](dateRange[0]);
        __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__["d" /* setDateFromStatic */](dateRange[0]);
        __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__["e" /* setDateTo */](dateRange[1]);
        __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__["f" /* setDateToStatic */](dateRange[1]);
        __WEBPACK_IMPORTED_MODULE_5__store_date_filters_setters__["g" /* setDateGap */]({ start: dateRange[0], end: dateRange[1] });
    }
};

var dispatchUrl = function dispatchUrl() {
    var queryUrlParams = {};

    if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().key !== '*:*') {
        queryUrlParams["q"] = __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().key;
    }

    if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().param) {
        queryUrlParams["dc"] = __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().param;
    }

    if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["b" /* currentPage */]() !== 1) {
        queryUrlParams["p"] = __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["b" /* currentPage */]();
    }

    if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().sorting) {
        queryUrlParams["s"] = __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().sorting;
    }

    if (__WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().rows !== 30) {
        queryUrlParams["ipp"] = __WEBPACK_IMPORTED_MODULE_0__store_searchStore_getters__["a" /* searchParams */]().rows;
    }

    if (!_.isEmpty(__WEBPACK_IMPORTED_MODULE_2__store_filters_getters__["a" /* getFilterParams */]())) {
        var objectFilters = __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__["a" /* getFilterParams */]();
        var objectFiltersString = '';

        for (var value in objectFilters) {
            objectFiltersString += objectFilters[value].name;
            objectFiltersString += ":";

            for (var params in objectFilters[value].filters) {
                objectFiltersString += objectFilters[value].filters[params];

                if (params != objectFilters[value].filters.length - 1) {
                    objectFiltersString += ",";
                }
            }

            if (value != objectFilters.length - 1) {
                objectFiltersString += "|";
            }
        }

        queryUrlParams["fq"] = objectFiltersString;
    }

    if (__WEBPACK_IMPORTED_MODULE_4__store_date_filters_getters__["f" /* getIsDate */]()) {
        queryUrlParams["dr"] = __WEBPACK_IMPORTED_MODULE_4__store_date_filters_getters__["g" /* getDateFromStatic */]() + "|" + __WEBPACK_IMPORTED_MODULE_4__store_date_filters_getters__["h" /* getDateToStatic */]();
    }

    var url = { query: queryUrlParams };
    return url;
};



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var groupElements = function groupElements(values) {
  var newValues = [];

  for (var i = 0; i < values.length; i += 2) {
    newValues.push({
      "name": values[i],
      "results": values[i + 1]
    });
  }
  return newValues;
};

/* harmony default export */ __webpack_exports__["a"] = (groupElements);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseResStringName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseStringDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseResString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_reusable_format_date__ = __webpack_require__(21);



var parseResStringName = function parseResStringName(str) {
  return str.match(new RegExp('{!tag=(.*)}'))[1];
};

var parseStringDate = function parseStringDate(str, name) {
  var tempResults = str.replace(/{!tag=(.*)}/, '');

  tempResults = tempResults.replace(new RegExp(name + ':'), '');
  tempResults = tempResults.match(/\[(.*?)\]/)[1];
  tempResults = tempResults.split(' ');

  return {
    from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__scripts_reusable_format_date__["a" /* default */])(tempResults[0]),
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__scripts_reusable_format_date__["a" /* default */])(tempResults[2])
  };
};

var parseResString = function parseResString(str, name) {
  var results = [];

  var tempResults = str.replace(/{!tag=(.*)}/, '');
  tempResults = tempResults.match(new RegExp(name + ': \"' + '(.*?)' + '\"', "gi"));

  function addRes(element) {
    results.push(element.match(name + ': \"' + '(.*)' + '\"', "gi")[1]);
  }
  tempResults.forEach(addRes);

  return {
    name: name,
    filters: results
  };
};



/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(349),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(332),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(331),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage_MainPage__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainPage_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Error_404__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Error_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Error_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Error_503__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Error_503___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Error_503__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MainPage_MainPage___default.a
  }, {
    path: '*',
    name: 'error-404',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Error_404___default.a
  }]
}));

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(348),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

module.exports = {
	"language": "en",
	"title": "FBC Newspapers",
	"langs": {
		"pl": "Polski",
		"en": "English"
	},
	"go_top": "Go to top",
	"fonts": {
		"name": {
			"default": "default",
			"medium": "medium",
			"big": "big"
		}
	},
	"search": {
		"form": {
			"select": {
				"params": {
					"param_1": {
						"name": "Title or keywords",
						"val": "",
						"autocomplete": "suggest_main"
					},
					"param_2": {
						"name": "Title",
						"val": "title_for_search",
						"autocomplete": "suggest_newspaper_title"
					},
					"param_3": {
						"name": "Keywords",
						"val": "subject",
						"autocomplete": "suggest_subject"
					}
				}
			},
			"input": {
				"placeholder": "Enter your query"
			},
			"button": {
				"search": "Search!"
			}
		},
		"results": {
			"title": "Newspapers",
			"no_results": "No results"
		},
		"info": {
			"title": "Results",
			"count": "Number of newspapers",
			"clear": "Clear search parameters"
		},
		"main": {
			"desc": "Newspapers from collections of Polish cultural and scientific institutions"
		}
	},
	"pagination": {
		"next": "next",
		"prev": "prev",
		"next_page": "next page",
		"prev_page": "previous page",
		"from_pages": "from"
	},
	"sorting": {
		"params": {
			"relevance": {
				"name": "Sort by relevance",
				"val": ""
			},
			"title": {
				"name": "Sort by title (alphabetically)",
				"val": "newspaper_title%20asc"
			},
			"date_desc": {
				"name": "Sort by release date - from newest",
				"val": "date_start%20asc"
			},
			"date_asc": {
				"name": "Sort by release date - from oldest",
				"val": "date_end%20desc"
			}
		}
	},
	"items_per_page": {
		"label": "items per page",
		"elems": {
			"first": {
				"name": "thirty",
				"val": 30
			},
			"second": {
				"name": "sixty",
				"val": 60
			},
			"third": {
				"name": "ninty",
				"val": 90
			}
		}
	},
	"filters": {
		"title": "Filters",
		"choose": "Choose filters",
		"select_all": "Select all",
		"deselect_all": "Deselect all",
		"submit": "Apply",
		"back": "Back",
		"reset": "Reset filters",
		"add": "Add filter",
		"clean": "Clean filters",
		"close": "Close filters",
		"clear": "Clear filter",
		"clear_all": "Clear all filters",
		"search": {
			"placeholder": "Type the first letter or phrase"
		},
		"date": {
			"reset": "Reset date",
			"from": "From",
			"to": "To",
			"placeholder": "Enter the year or month or full date. You can also narrow down the dates by clicking on the chart",
			"total_number": "The total number of newspapers",
			"not_valid": "The date is not correct."
		},
		"emptylist": "No matches. Change the entered phrase."
	},
	"langCode": {
		"akk": "Akkadian",
		"gwi": "Gwich'in",
		"eka": "Ekajuk",
		"nde": "Ndebele, North; North Ndebele",
		"sve": "Serili",
		"ijo": "Ijo languages",
		"aka": "Akan",
		"yid": "Yiddish",
		"sux": "Sumerian",
		"uig": "Uighur; Uyghur",
		"ton": "Tonga (Tonga Islands)",
		"sus": "Susu",
		"mis": "Uncoded languages",
		"por": "Portuguese",
		"loz": "Lozi",
		"tog": "Tonga (Nyasa)",
		"poo": "Central Pomo",
		"sun": "Sundanese",
		"zbl": "Blissymbols; Blissymbolics; Bliss",
		"pon": "Pohnpeian",
		"min": "Minangkabau",
		"pol": "Polish",
		"suk": "Sukuma",
		"kut": "Kutenai",
		"lol": "Mongo",
		"mic": "Mi'kmaq; Micmac",
		"kur": "Kurdish",
		"iii": "Sichuan Yi; Nuosu",
		"kum": "Kumyk",
		"hol": "Holu",
		"nbl": "Ndebele, South; South Ndebele",
		"zap": "Zapotec",
		"ain": "Ainu",
		"cus": "Cushitic languages",
		"guj": "Gujarati",
		"kua": "Kuanyama; Kwanyama",
		"doi": "Dogri",
		"jbo": "Lojban",
		"zza": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki",
		"oto": "Otomian languages",
		"rar": "Rarotongan; Cook Islands Maori",
		"vai": "Vai",
		"rap": "Rapanui",
		"nav": "Navajo; Navaho",
		"nau": "Nauru",
		"raj": "Rajasthani",
		"nzi": "Nzima",
		"ota": "Turkish, Ottoman (1500-1928)",
		"ssw": "Swati",
		"nap": "Neapolitan",
		"jav": "Javanese",
		"uga": "Ugaritic",
		"tmh": "Tamashek",
		"nai": "North American Indian languages",
		"nah": "Nahuatl languages",
		"oss": "Ossetian; Ossetic",
		"fat": "Fanti",
		"fas": "Persian",
		"egy": "Egyptian (Ancient)",
		"fao": "Faroese",
		"zxx": "No linguistic content",
		"fan": "Fang",
		"ssa": "Nilo-Saharan languages",
		"bat": "Baltic languages",
		"mga": "Irish, Middle (900-1200)",
		"bas": "Basa",
		"nyo": "Nyoro",
		"nyn": "Nyankole",
		"gsw": "Swiss German; Alemannic; Alsatian",
		"hmo": "Hiri Motu",
		"nym": "Nyamwezi",
		"hmn": "Hmong; Mong",
		"ban": "Balinese",
		"bam": "Bambara",
		"osa": "Osage",
		"bal": "Baluchi",
		"hmj": "Gejia",
		"bak": "Bashkir",
		"bai": "Bamileke languages",
		"srr": "Serer",
		"tli": "Tlingit",
		"srp": "Serbian",
		"tlh": "Klingon; tlhIngan-Hol",
		"nya": "Chichewa; Chewa; Nyanja",
		"bad": "Banda languages",
		"srn": "Sranan Tongo",
		"pli": "Pali",
		"orm": "Oromo",
		"srd": "Sardinian",
		"kru": "Kurukh",
		"byn": "Blin; Bilin",
		"ori": "Oriya",
		"csb": "Kashubian",
		"kro": "Kru languages",
		"krl": "Karelian",
		"grt": "Garo",
		"tkl": "Tokelau",
		"afr": "Afrikaans",
		"efi": "Efik",
		"grn": "Guarani",
		"mes": "Masmaje",
		"krc": "Karachay-Balkar",
		"men": "Mende",
		"crp": "Creoles and pidgins ",
		"afh": "Afrihili",
		"sqi": "Albanian",
		"grc": "Greek, Ancient (to 1453)",
		"grb": "Grebo",
		"afa": "Afro-Asiatic languages",
		"crh": "Crimean Tatar; Crimean Turkish",
		"cre": "Cree",
		"udm": "Udmurt",
		"nwc": "Classical Newari; Old Newari; Classical Nepal Bhasa",
		"mdr": "Mandar",
		"ido": "Ido",
		"mdf": "Moksha",
		"spa": "Spanish; Castilian",
		"tiv": "Tiv",
		"ady": "Adyghe; Adygei",
		"tir": "Tigrinya",
		"zun": "Zuni",
		"zul": "Zulu",
		"wol": "Wolof",
		"sot": "Sotho, Southern",
		"kpe": "Kpelle",
		"tig": "Tigre",
		"son": "Songhai languages",
		"som": "Somali",
		"cpp": "Creoles and pidgins, Portuguese-based ",
		"rus": "Russian",
		"lit": "Lithuanian",
		"rup": "Aromanian; Arumanian; Macedo-Romanian",
		"sog": "Sogdian",
		"run": "Rundi",
		"lin": "Lingala",
		"ada": "Adangme",
		"lim": "Limburgan; Limburger; Limburgish",
		"cpf": "Creoles and pidgins, French-based ",
		"hit": "Hittite",
		"kos": "Kosraean",
		"xho": "Xhosa",
		"cpe": "Creoles and pidgins, English based",
		"kor": "Korean",
		"kon": "Kongo",
		"hin": "Hindi",
		"kom": "Komi",
		"div": "Divehi; Dhivehi; Maldivian",
		"him": "Himachali languages; Western Pahari languages",
		"got": "Gothic",
		"hil": "Hiligaynon",
		"kok": "Konkani",
		"gor": "Gorontalo",
		"gon": "Gondi",
		"din": "Dinka",
		"nub": "Nubian languages",
		"cos": "Corsican",
		"fur": "Friulian",
		"cor": "Cornish",
		"phn": "Phoenician",
		"goh": "German, Old High (ca.750-1050)",
		"cop": "Coptic",
		"snk": "Soninke",
		"ach": "Acoli",
		"yap": "Yapese",
		"tha": "Thai",
		"yao": "Yao",
		"ful": "Fulah",
		"phi": "Philippine languages",
		"ace": "Achinese",
		"ibo": "Igbo",
		"snd": "Sindhi",
		"sna": "Shona",
		"bul": "Bulgarian",
		"uzb": "Uzbek",
		"bug": "Buginese",
		"iba": "Iban",
		"tgl": "Tagalog",
		"bua": "Buriat",
		"sms": "Skolt Sami",
		"tgk": "Tajik",
		"ebg": "Ebughu",
		"mas": "Masai",
		"mar": "Marathi",
		"smo": "Samoan",
		"map": "Austronesian languages",
		"smn": "Inari Sami",
		"abk": "Abkhazian",
		"mao": "Maori",
		"man": "Mandingo",
		"mal": "Malayalam",
		"smj": "Lule Sami",
		"mak": "Makasar",
		"smi": "Sami languages",
		"mai": "Maithili",
		"mah": "Marshallese",
		"mag": "Magahi",
		"sme": "Northern Sami",
		"mad": "Madurese",
		"sma": "Southern Sami",
		"btk": "Batak languages",
		"nso": "Pedi; Sepedi; Northern Sotho",
		"myv": "Erzya",
		"wln": "Walloon",
		"slv": "Slovenian",
		"dgr": "Dogrib",
		"aar": "Afar",
		"myn": "Mayan languages",
		"aze": "Azerbaijani",
		"kmb": "Kimbundu",
		"gmh": "German, Middle High (ca.1050-1500)",
		"slk": "Slovak",
		"cmn": "Mandarin",
		"sli": "Lower Silesian",
		"mya": "Burmese",
		"sla": "Slavic languages",
		"cmc": "Chamic languages",
		"tet": "Tetum",
		"glv": "Manx",
		"ter": "Tereno",
		"aym": "Aymara",
		"fry": "Western Frisian",
		"tem": "Timne",
		"tel": "Telugu",
		"lez": "Lezghian",
		"frs": "Eastern Frisian",
		"frr": "Northern Frisian",
		"peo": "Persian, Old (ca.600-400 B.C.)",
		"fro": "French, Old (842-ca.1400)",
		"glg": "Galician",
		"let": "Lesing-Gelimi",
		"frm": "French, Middle (ca.1400-1600)",
		"gle": "Irish",
		"ski": "Sika",
		"jrb": "Judeo-Arabic",
		"gla": "Gaelic; Scottish Gaelic",
		"her": "Herero",
		"nqo": "N'Ko",
		"fra": "French",
		"deu": "German",
		"mwr": "Marwari",
		"bre": "Breton",
		"bra": "Braj",
		"mwl": "Mirandese",
		"den": "Slave (Athapascan)",
		"del": "Delaware",
		"heb": "Hebrew",
		"ewo": "Ewondo",
		"oji": "Ojibwa",
		"ewe": "Ewe",
		"jpr": "Judeo-Persian",
		"vot": "Votic",
		"sit": "Sino-Tibetan languages",
		"jpn": "Japanese",
		"sio": "Siouan languages",
		"sin": "Sinhala; Sinhalese",
		"vol": "Volapük",
		"awa": "Awadhi",
		"ron": "Romanian; Moldavian; Moldovan",
		"rom": "Romany",
		"sid": "Sidamo",
		"nor": "Norwegian",
		"kir": "Kirghiz; Kyrgyz",
		"roh": "Romansh",
		"avt": "Au",
		"non": "Norse, Old",
		"kin": "Kinyarwanda",
		"mus": "Creek",
		"kik": "Kikuyu; Gikuyu",
		"roa": "Romance languages",
		"nog": "Nogai",
		"mun": "Munda languages",
		"que": "Quechua",
		"mul": "Multiple languages",
		"gil": "Gilbertese",
		"nob": "Bokmål, Norwegian; Norwegian Bokmål",
		"ave": "Avestan",
		"shn": "Shan",
		"znd": "Zande languages",
		"ava": "Avaric",
		"fon": "Fon",
		"eus": "Basque",
		"bos": "Bosnian",
		"aus": "Australian languages",
		"nno": "Norwegian Nynorsk; Nynorsk, Norwegian",
		"xal": "Kalmyk; Oirat",
		"kho": "Khotanese; Sakan",
		"tat": "Tatar",
		"khm": "Central Khmer",
		"boh": "Boma",
		"khi": "Khoisan languages",
		"bod": "Tibetan",
		"tam": "Tamil",
		"chy": "Cheyenne",
		"pau": "Palauan",
		"chv": "Chuvash",
		"tai": "Tai languages",
		"chu": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
		"tah": "Tahitian",
		"pap": "Papiamento",
		"kha": "Khasi",
		"sgn": "Sign Languages",
		"chr": "Cherokee",
		"pan": "Panjabi; Punjabi",
		"lav": "Latvian",
		"pam": "Pampanga; Kapampangan",
		"chp": "Chipewyan; Dene Suline",
		"pal": "Pahlavi",
		"lat": "Latin",
		"cho": "Choctaw",
		"chn": "Chinook jargon",
		"chm": "Mari",
		"bnt": "Bantu (Other)",
		"tyv": "Tuvinian",
		"chk": "Chuukese",
		"pag": "Pangasinan",
		"lao": "Lao",
		"haw": "Hawaiian",
		"lam": "Lamba",
		"hau": "Hausa",
		"chg": "Chagatai",
		"hat": "Haitian; Haitian Creole",
		"sga": "Irish, Old (to 900)",
		"che": "Chechen",
		"paa": "Papuan languages",
		"lah": "Lahnda",
		"ita": "Italian",
		"day": "Land Dayak languages",
		"chb": "Chibcha",
		"cha": "Chamorro",
		"dzo": "Dzongkha",
		"lad": "Ladino",
		"lac": "Lesing-Gelimi",
		"hai": "Haida",
		"dar": "Dargwa",
		"ath": "Athapascan languages",
		"dan": "Danish",
		"dak": "Dakota",
		"isl": "Icelandic",
		"est": "Estonian",
		"msa": "Malay",
		"dyu": "Dyula",
		"ast": "Asturian; Bable; Leonese; Asturleonese",
		"urd": "Urdu",
		"hye": "Armenian",
		"asm": "Assamese",
		"wen": "Sorbian languages",
		"wel": "Welsh",
		"nld": "Dutch; Flemish",
		"ser": "Serrano",
		"sem": "Semitic languages",
		"iro": "Iroquoian languages",
		"sel": "Selkup",
		"arw": "Arawak",
		"aru": "arawá",
		"gez": "Geez",
		"art": "Artificial languages",
		"ira": "Iranian languages",
		"arp": "Arapaho",
		"twi": "Twi",
		"arn": "Mapudungun; Mapuche",
		"bla": "Siksika",
		"gem": "Germanic languages",
		"arg": "Aragonese",
		"ces": "Czech",
		"arc": "Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)",
		"ypk": "Yupik languages",
		"arb": "Standard Arabic",
		"ara": "Arabic",
		"cel": "Celtic languages",
		"ceb": "Cebuano",
		"tvl": "Tuvalu",
		"yor": "Yoruba",
		"scs": "North Slavey",
		"sco": "Scots",
		"scn": "Sicilian",
		"ipk": "Inupiaq",
		"vie": "Vietnamese",
		"tut": "Altaic languages",
		"niu": "Niuean",
		"epo": "Esperanto",
		"tur": "Turkish",
		"tup": "Tupi languages",
		"oci": "Occitan (post 1500); Provençal",
		"tum": "Tumbuka",
		"tuk": "Turkmen",
		"pus": "Pushto; Pashto",
		"zho": "Chinese",
		"mos": "Mossi",
		"mon": "Mongolian",
		"lus": "Lushai",
		"fiu": "Finno-Ugrian languages",
		"nic": "Niger-Kordofanian languages",
		"nia": "Nias",
		"moh": "Mohawk",
		"luo": "Luo (Kenya and Tanzania)",
		"lun": "Lunda",
		"apa": "Apache languages",
		"zha": "Zhuang; Chuang",
		"fin": "Finnish",
		"jid": "Bu",
		"fil": "Filipino; Pilipino",
		"lui": "Luiseno",
		"fij": "Fijian",
		"bis": "Bislama",
		"lug": "Ganda",
		"hup": "Hupa",
		"hun": "Hungarian",
		"bin": "Bini; Edo",
		"lub": "Luba-Katanga",
		"szw": "Sawai",
		"lua": "Luba-Lulua",
		"bik": "Bikol",
		"und": "Undetermined",
		"was": "Washo",
		"war": "Waray",
		"bih": "Bihari languages",
		"dun": "Dusun Deyah",
		"ltz": "Luxembourgish; Letzeburgesch",
		"dum": "Dutch, Middle (ca.1050-1350)",
		"mno": "Manobo languages",
		"wal": "Walamo",
		"sat": "Santali",
		"szl": "Silesian",
		"wak": "Wakashan languages",
		"bia": "Badimaya",
		"sas": "Sasak",
		"kbd": "Kabardian",
		"mni": "Manipuri",
		"san": "Sanskrit",
		"sam": "Samaritan Aramaic",
		"dua": "Duala",
		"sal": "Salishan languages",
		"mnc": "Manchu",
		"sai": "South American Indian (Other)",
		"kaz": "Kazakh",
		"sah": "Yakut",
		"sag": "Sango",
		"kaw": "Kawi",
		"inh": "Ingush",
		"gba": "Gbaya",
		"sad": "Sandawe",
		"kau": "Kanuri",
		"kat": "Georgian",
		"ine": "Indo-European languages",
		"bho": "Bhojpuri",
		"kas": "Kashmiri",
		"ind": "Indonesian",
		"enm": "English, Middle (1100-1500)",
		"kar": "Karen languages",
		"inc": "Indic languages",
		"tso": "Tsonga",
		"tsn": "Tswana",
		"ina": "Interlingua (International Auxiliary Language Association)",
		"gay": "Gayo",
		"kan": "Kannada",
		"kam": "Kamba",
		"eng": "English",
		"anp": "Angika",
		"syr": "Syriac",
		"umb": "Umbundu",
		"kal": "Kalaallisut; Greenlandic",
		"tsi": "Tsimshian",
		"end": "Ende",
		"enc": "En",
		"ang": "English, Old (ca.450-1100)",
		"kac": "Kachin; Jingpho",
		"cau": "Caucasian languages",
		"kab": "Kabyle",
		"cat": "Catalan; Valencian",
		"kaa": "Kara-Kalpak",
		"car": "Galibi Carib",
		"syc": "Classical Syriac",
		"gaa": "Ga",
		"cai": "Central American Indian languages",
		"cad": "Caddo",
		"mlt": "Maltese",
		"zen": "Zenaga",
		"hsb": "Upper Sorbian",
		"pro": "Provençal, Old (to 1500)",
		"amh": "Amharic",
		"cym": "Welsh",
		"au": "australian",
		"ven": "Venda",
		"dsb": "Lower Sorbian",
		"mlg": "Malagasy",
		"ilo": "Iloko",
		"elx": "Elamite",
		"hrv": "Croatian",
		"ukr": "Ukrainian",
		"pra": "Prakrit languages",
		"new": "Nepal Bhasa; Newari",
		"qaa-qtz": "Reserved for local use",
		"ile": "Interlingue; Occidental",
		"ell": "Greek, Modern (1453-)",
		"alt": "Southern Altai",
		"nep": "Nepali",
		"iku": "Inuktitut",
		"alg": "Algonquian languages",
		"ale": "Aleut",
		"mkh": "Mon-Khmer languages",
		"swe": "Swedish",
		"dra": "Dravidian languages",
		"mkd": "Macedonian",
		"swa": "Swahili",
		"ber": "Berber languages",
		"nds": "Low German; Low Saxon; German, Low; Saxon, Low",
		"ben": "Bengali",
		"bem": "Bemba",
		"bel": "Belarusian",
		"ndo": "Ndonga",
		"bej": "Beja; Bedawiyet",
		"tpi": "Tok Pisin",
		"unknown": "Unknown"
	},
	"global": {
		"title": "Title",
		"subject": "Subject",
		"language": "Language",
		"place_of_publishing": "Place of publishing",
		"data_provider": "Data provider",
		"issue_period": "Issue period",
		"date_filter": "Date range",
		"count": "Number of newspapers in FBC",
		"license": "License",
		"publisher": "Publisher",
		"keywords": "Keywords",
		"show_FBC": "Show in FBC",
		"button": {
			"submit": "Submit",
			"cancel": "Cancel",
			"close": "Close",
			"totop": "To top"
		}
	},
	"header": {
		"contrast": "Change contrast",
		"font": "Change font size",
		"lang": "Change language",
		"logo": "Back to homepage"
	},
	"footer": {
		"text": {
			"first": "Service FBC newspapers is held by",
			"second": "and is a service in the",
			"PSNC": {
				"full": "Poznań Supercomputing and Networking Center",
				"short": "PSNC",
				"link": "http://www.man.poznan.pl/online/en/"
			},
			"PIONIER": {
				"full": "Polish Optical Internet PIONIER network",
				"short": "PIONIER",
				"link": "http://www.pionier.net.pl/online/en/"
			}
		},
		"menu": {
			"link_1": {
				"title": "FBC",
				"link": "https://fbc.pionier.net.pl/?lang=en"
			},
			"link_2": {
				"title": "Our partners",
				"link": "http://fbc.pionier.net.pl/pro/zrodla"
			},
			"link_3": {
				"title": "Join FBC",
				"link": "http://fbc.pionier.net.pl/pro/wspolpraca/dla-dostawcow-danych/"
			},
			"link_4": {
				"title": "FBC on Facebook",
				"link": "https://www.facebook.com/FederacjaBibliotekCyfrowych"
			},
			"link_5": {
				"title": "Contact",
				"link": "http://fbc.pionier.net.pl/pro/kontakt/"
			}
		}
	},
	"cookies": {
		"bar": {
			"text": "We use cookies to facilitate your use of our services. If you do not want the cookies to be saved on your hard disk, change the settings of your browser.",
			"link": "Check information about cookies and privacy policy."
		},
		"modal": {
			"title": "Cookies on our website",
			"text": "<p>Our website uses the cookies to facilitate your use of our services. A cookie is a small file of letters and numbers that we put on your computer if you agree. These cookies allow us to distinguish you from other users of the website which helps us to provide you with a good experience when you browse our website and allows us to improve our site. In some cases use of cookies is necessary for the proper functioning of the services provided by the website.</p><p>Most web browsers allow some control of most cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href=\"http://allaboutcookies.org\" target=\"_blank\">allaboutcookies.org</a>.</p><p><strong>Copyright © 2017 PSNC</strong></p>"
		}
	},
	"altimg": {
		"logo": "FBC Newspapers Logo"
	}
};

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = {
	"language": "pl",
	"title": "FBC Czasopisma",
	"langs": {
		"pl": "Polski",
		"en": "English"
	},
	"go_top": "Idź do góry",
	"fonts": {
		"name": {
			"default": "domyślna",
			"medium": "średnia",
			"big": "duża"
		}
	},
	"search": {
		"form": {
			"select": {
				"params": {
					"param_1": {
						"name": "Tytuł lub słowa kluczowe",
						"val": "",
						"autocomplete": "suggest_main"
					},
					"param_2": {
						"name": "Tytuł",
						"val": "title_for_search",
						"autocomplete": "suggest_newspaper_title"
					},
					"param_3": {
						"name": "Słowa kluczowe",
						"val": "subject",
						"autocomplete": "suggest_subject"
					}
				}
			},
			"input": {
				"placeholder": "Podaj frazę do wyszukania"
			},
			"button": {
				"search": "Szukaj"
			}
		},
		"results": {
			"title": "Czasopisma",
			"no_results": "Brak wyników"
		},
		"info": {
			"title": "Wyniki",
			"count": "Liczba czasopism",
			"clear": "Wyczyść zapytanie"
		},
		"main": {
			"desc": "Czasopisma ze zbiorów polskich instytucji kultury i nauki"
		}
	},
	"pagination": {
		"next": "Następna",
		"prev": "Poprzednia",
		"next_page": "Następna strona",
		"prev_page": "Poprzednia strona",
		"from_pages": "z"
	},
	"sorting": {
		"params": {
			"relevance": {
				"name": "Sortuj wg trafności",
				"val": ""
			},
			"title": {
				"name": "Sortuj wg tytułu (alfabetycznie)",
				"val": "newspaper_title%20asc"
			},
			"date_desc": {
				"name": "Sortuj wg daty wydania - od najnowszego numeru",
				"val": "date_start%20asc"
			},
			"date_asc": {
				"name": "Sortuj wg daty wydania - od najstarszego numeru",
				"val": "date_end%20desc"
			}
		}
	},
	"items_per_page": {
		"label": "wyników na stronie",
		"elems": {
			"first": {
				"name": "trzydziesci",
				"val": 30
			},
			"second": {
				"name": "sześćdziesiąt",
				"val": 60
			},
			"third": {
				"name": "dziewięćdziesiąt",
				"val": 90
			}
		}
	},
	"filters": {
		"title": "Filtry",
		"choose": "Wybierz filtry",
		"select_all": "Zaznacz wszystkie",
		"deselect_all": "Wyczyść zaznaczone",
		"submit": "Zastosuj",
		"reset": "Resetuj filtry",
		"back": "Wróć",
		"add": "Dodaj filtr",
		"clean": "Wyczyść filtry",
		"close": "Zamknij filtry",
		"clear": "Wyczyść filtr",
		"clear_all": "Wyczyść wszystkie filtry",
		"search": {
			"placeholder": "Wpisz pierwszą literę lub szukaną frazę"
		},
		"date": {
			"reset": "Resetuj daty",
			"from": "Od",
			"to": "Do",
			"placeholder": "Wpisz rok lub miesiąc i rok lub pełną datę albo skorzystaj z listy dat poniżej.",
			"total_number": "Łączna liczba czasopism",
			"not_valid": "Podana data nie jest poprawna."
		},
		"emptylist": "Brak dopasowań. Zmień wprowadzoną frazę."
	},
	"langCode": {
		"akk": "akadyjski",
		"gwi": "gwich'in",
		"eka": "ekajuk",
		"nde": "ndebele północny (Zimbabwe)",
		"sve": "serili",
		"ijo": "ijo",
		"aka": "akan",
		"yid": "jidysz",
		"sux": "sumeryjski",
		"uig": "ujgurski",
		"ton": "tongijski",
		"sus": "susu",
		"mis": "różne języki",
		"por": "portugalski",
		"loz": "lozi",
		"tog": "tonga (Malawi)",
		"poo": "central pomo",
		"sun": "sundajski",
		"zbl": "Bliss-Symbol (język sztuczny)",
		"pon": "ponape",
		"min": "minangkabau",
		"pol": "polski",
		"suk": "sukuma",
		"kut": "kutenai",
		"lol": "mongo-nkundu",
		"mic": "micmac",
		"kur": "kurdyjski",
		"iii": "yi syczuański (nuosu)",
		"kum": "kumycki",
		"hol": "holu",
		"nbl": "ndebele południowy (RPA)",
		"zap": "zapoteckie",
		"ain": "ajnoski (ajnu)",
		"cus": "kuszyckie (inne)",
		"guj": "gudźarati",
		"kua": "kwanyama",
		"doi": "dogri",
		"jbo": "lojban (język sztuczny)",
		"zza": "zazaki",
		"oto": "otomi-mangue, języki (otomang)",
		"rar": "rarotonga",
		"vai": "vai",
		"rap": "rapanui",
		"nav": "nawaho",
		"nau": "nauru",
		"raj": "rajasthani",
		"nzi": "nzema",
		"ota": "turecko-osmański (1500-1928)",
		"ssw": "suazi",
		"nap": "neapolitański",
		"jav": "jawajski",
		"uga": "ugarycki",
		"tmh": "tamaszek (tuareski)",
		"nai": "Indian północnoamerykańskich (inne)",
		"nah": "nahuatl",
		"oss": "osetyjski",
		"fat": "fante",
		"fas": "perski",
		"egy": "egipski starożytny",
		"fao": "farerski",
		"zxx": "dokument nietekstowy",
		"fan": "fang",
		"ssa": "nilo-saharyjskie (inne)",
		"bat": "bałtyckie (inne)",
		"mga": "średnioirlandzki (1100-1550)",
		"bas": "basa",
		"nyo": "nyoro",
		"nyn": "nyankole",
		"gsw": "niemiecki szwajcarski",
		"hmo": "hiri motu",
		"nym": "nyamwezi",
		"hmn": "hmong",
		"ban": "balijski",
		"bam": "bambara",
		"osa": "osage",
		"bal": "beludżyjski",
		"hmj": "gejia",
		"bak": "baszkirski",
		"bai": "bamileke, języki",
		"srr": "serer",
		"tli": "tlingit",
		"srp": "serbski",
		"tlh": "klingoński (język sztuczny)",
		"nya": "nyanja",
		"bad": "banda, języki",
		"srn": "sranan tongo (surinamski)",
		"pli": "pali",
		"orm": "oromo",
		"srd": "sardyński",
		"kru": "kurukh",
		"byn": "bilin",
		"ori": "orija",
		"csb": "kaszubski",
		"kro": "kru, języki (inne)",
		"krl": "karelski",
		"grt": "garo",
		"tkl": "tokelau",
		"afr": "afrykanerski",
		"efi": "efik",
		"grn": "guarani",
		"mes": "masmaje",
		"krc": "karaczajsko-bałkarski",
		"men": "mende",
		"crp": "kreolskie i pidżynowe (inne)",
		"afh": "afrihili (język sztuczny)",
		"sqi": "albański",
		"grc": "grecki starożytny (starogrecki) (do 1453)",
		"grb": "grebo",
		"afa": "afroazjatyckie (inne)",
		"crh": "krymskotatarski",
		"cre": "kri",
		"udm": "udmurcki (wotiacki)",
		"nwc": "newarski klasyczny",
		"mdr": "mandarski",
		"ido": "ido",
		"mdf": "moksza",
		"spa": "hiszpański",
		"tiv": "tiw",
		"ady": "adygejski",
		"tir": "tigrinia",
		"zun": "zuni",
		"zul": "zulu",
		"wol": "wolof",
		"sot": "sotho południowy",
		"kpe": "kpelle",
		"tig": "tigre",
		"son": "songhaj",
		"som": "somalijski",
		"cpp": "kreolskie i pidżynowe na bazie języka portugalskiego (inne)",
		"rus": "rosyjski",
		"lit": "litewski",
		"rup": "arumuński",
		"sog": "sogdyjski",
		"run": "rundi",
		"lin": "lingala",
		"ada": "adangme",
		"lim": "limburski",
		"cpf": "kreolskie i pidżynowe na bazie języka francuskiego (inne)",
		"hit": "hetycki",
		"kos": "kusajski (kosrae)",
		"xho": "xhosa (khosa)",
		"cpe": "kreolskie i pidżynowe na bazie języka angielskiego (inne)",
		"kor": "koreański",
		"kon": "kongo",
		"hin": "hindi",
		"kom": "komi",
		"div": "malediwski (divehi)",
		"him": "pahari zachodnie, języki (himachali)",
		"got": "gocki",
		"hil": "hiligaynon",
		"kok": "konkani",
		"gor": "gorontalo",
		"gon": "gondi",
		"din": "dinka",
		"nub": "nubijskie",
		"cos": "korsykański",
		"fur": "friulski",
		"cor": "kornijski (kornwalijski)",
		"phn": "fenicki",
		"goh": "staro-wysoko-niemiecki (ok.750-1050)",
		"cop": "koptyjski",
		"snk": "soninke",
		"ach": "aczoli",
		"yap": "japski",
		"tha": "tajski (syjamski)",
		"yao": "yao (Afryka)",
		"ful": "fulani",
		"phi": "filipińskie (inne)",
		"ace": "Achinese",
		"ibo": "igbo",
		"snd": "sindhi",
		"sna": "szona",
		"bul": "bułgarski",
		"uzb": "uzbecki",
		"bug": "bugijski",
		"iba": "iban",
		"tgl": "tagalog (tagalski)",
		"bua": "buriacki",
		"sms": "lapoński skolt",
		"tgk": "tadżycki",
		"ebg": "ebughu",
		"mas": "masajski",
		"mar": "marathi",
		"smo": "samoański",
		"map": "austronezyjskie (malajo-polinezyjskie) (inne)",
		"smn": "lapoński inari",
		"abk": "abchaski",
		"mao": "maoryjski",
		"man": "mandingo",
		"mal": "malajalam",
		"smj": "lapoński lule",
		"mak": "makasarski",
		"smi": "lapońskie (inne)",
		"mai": "maithili",
		"mah": "marszalski",
		"mag": "magadhi",
		"sme": "lapoński północny",
		"mad": "madurski",
		"sma": "lapoński południowy",
		"btk": "batackie (Indonezja)",
		"nso": "sotho północny",
		"myv": "erzja",
		"wln": "waloński",
		"slv": "słoweński",
		"dgr": "dogrib",
		"aar": "afar",
		"myn": "majańskie",
		"aze": "azerbejdżański",
		"kmb": "kimbundu",
		"gmh": "średnio-wysoko-niemiecki (ok. 1050-1500)",
		"slk": "słowacki",
		"cmn": "mandaryński",
		"sli": "dolnośląski ",
		"mya": "birmański",
		"sla": "słowiańskie (inne)",
		"cmc": "czamskie",
		"tet": "tetum",
		"glv": "mański (manx)",
		"ter": "tereno",
		"aym": "ajmara",
		"fry": "fryzyjski",
		"tem": "temne",
		"tel": "telugu",
		"lez": "lezgiński",
		"frs": "fryzyjski, wschodni",
		"frr": "fryzyjski, północny",
		"peo": "staroperski (ok. 600-400 p.n.e.)",
		"fro": "starofrancuski (ok. 842-1300)",
		"glg": "galicyjski",
		"let": "lesing-gelimi",
		"frm": "średniofrancuski (ok. 1300-1600)",
		"gle": "irlandzki",
		"ski": "Sika",
		"jrb": "judeo-arabski",
		"gla": "gaelicki (szkocki)",
		"her": "herero",
		"nqo": "n'ko",
		"fra": "francuski",
		"deu": "niemiecki",
		"mwr": "marwari",
		"bre": "bretoński",
		"bra": "bradź",
		"mwl": "mirandyjski",
		"den": "niewolnicze (atapaskańskie)",
		"del": "delaware",
		"heb": "hebrajski",
		"ewo": "ewondo",
		"oji": "odżibwa",
		"ewe": "ewe",
		"jpr": "judeo-perski",
		"vot": "wocki",
		"sit": "chińsko-tybetańskie (inne)",
		"jpn": "japoński",
		"sio": "siouańskie (języki Siuksów) (inne)",
		"sin": "syngaleski",
		"vol": "volapück",
		"awa": "awadhi",
		"ron": "rumuński",
		"rom": "romani (cygański)",
		"sid": "sidamo",
		"nor": "norweski",
		"kir": "kirgiski",
		"roh": "retoromański (romansz)",
		"avt": "au",
		"non": "staronordyjski",
		"kin": "kinyarwanda",
		"mus": "creek (muskogi)",
		"kik": "kikuju",
		"roa": "romańskie (inne)",
		"nog": "nogajski",
		"mun": "mundajskie (inne)",
		"que": "keczua",
		"mul": "wiele języków",
		"gil": "gilbertański",
		"nob": "norweski bokmål",
		"ave": "awestyjski",
		"shn": "szan",
		"znd": "zande, języki",
		"ava": "awarski",
		"fon": "fon",
		"eus": "baskijski",
		"bos": "bośniacki",
		"aus": "australijskie",
		"nno": "norweski nynorsk",
		"xal": "ojracki (kałmucki)",
		"kho": "chotański",
		"tat": "tatarski",
		"khm": "khmerski",
		"boh": "boma",
		"khi": "khoisan, języki (inne)",
		"bod": "tybetański",
		"tam": "tamilski",
		"chy": "cheyenne",
		"pau": "palau",
		"chv": "czuwaski",
		"tai": "tajskie (inne)",
		"chu": "staro-cerkiewno-słowiański",
		"tah": "tahitański",
		"pap": "papiamento",
		"kha": "khasi",
		"sgn": "migowe, języki",
		"chr": "czirokeski",
		"pan": "pendżabski",
		"lav": "łotewski",
		"pam": "pampangan",
		"chp": "chipewyan",
		"pal": "pahlawi",
		"lat": "łaciński",
		"cho": "choctaw",
		"chn": "chinook jargon",
		"chm": "maryjski (czeremiski)",
		"bnt": "bantu (inne)",
		"tyv": "tuwiński",
		"chk": "czukocki",
		"pag": "pangasinan",
		"lao": "laotański",
		"haw": "hawajski",
		"lam": "lamba (Zambia i Kongo)",
		"hau": "hausa",
		"chg": "czagatajski",
		"hat": "haitański",
		"sga": "staroirlandzki (do 1100)",
		"che": "czeczeński",
		"paa": "papuaskie (inne)",
		"lah": "lahnda",
		"ita": "włoski",
		"day": "dajackie",
		"chb": "czibczańskie",
		"cha": "czamorro",
		"dzo": "dzongka",
		"lad": "ladino",
		"lac": "lacandon",
		"hai": "haida",
		"dar": "dargwijski",
		"ath": "atapaskańskie (inne)",
		"dan": "duński",
		"dak": "dakota",
		"isl": "islandzki",
		"est": "estoński",
		"msa": "malajski",
		"dyu": "dyula",
		"ast": "asturyjski",
		"urd": "urdu",
		"hye": "ormiański",
		"asm": "assamski",
		"wen": "łużyckie (inne)",
		"wel": "walijski",
		"nld": "niderlandzki",
		"ser": "serrano",
		"sem": "semickie (inne)",
		"iro": "irokeskie (inne)",
		"sel": "selkupski",
		"arw": "arawaskie",
		"aru": "arawá",
		"gez": "ge'ez (gyyz)",
		"art": "sztuczne (inne)",
		"ira": "irańskie (inne)",
		"arp": "arapaho",
		"twi": "twi (aszanti)",
		"arn": "araukański",
		"bla": "siksika (język Czarnych Stóp)",
		"gem": "germańskie (inne)",
		"arg": "aragoński",
		"ces": "czeski",
		"arc": "aramejski",
		"ypk": "jupik, języki",
		"arb": "arabski",
		"ara": "arabski",
		"cel": "celtyckie (inne)",
		"ceb": "cebuański (cebuano)",
		"tvl": "tuvalu",
		"yor": "joruba",
		"scs": "north slavey",
		"sco": "szkocki",
		"scn": "sycylijski",
		"ipk": "inupiak",
		"vie": "wietnamski",
		"tut": "ałtajskie (inne)",
		"niu": "niue",
		"epo": "esperanto",
		"tur": "turecki",
		"tup": "tupi, języki",
		"oci": "prowansalski (oksytański)",
		"tum": "tumbuka",
		"tuk": "turkmeński",
		"pus": "paszto (pusztu)",
		"zho": "chiński (mandaryński)",
		"mos": "mossi (mooré)",
		"mon": "mongolski",
		"lus": "lushai",
		"fiu": "ugrofińskie (inne)",
		"nic": "nigero-kongijskie (kongo-kordofańskie) (inne)",
		"nia": "nias",
		"moh": "mohawk",
		"luo": "luo (Kenia i Tanzania)",
		"lun": "lunda",
		"apa": "apaczeańskie (języki Apaczów)",
		"zha": "zhuang",
		"fin": "fiński",
		"jid": "bu",
		"fil": "filipiński (pilipino)",
		"lui": "luiseno",
		"fij": "fidżyjski",
		"bis": "bislama",
		"lug": "ganda",
		"hup": "hupa",
		"hun": "węgierski",
		"bin": "bini",
		"lub": "luba-katanga",
		"szw": "sawai",
		"lua": "luba-lulua (kasai)",
		"bik": "bikol",
		"und": "nieokreślony",
		"was": "washo",
		"war": "warajski (waray-waray)",
		"bih": "biharskie (inne)",
		"dun": "dusun deyah",
		"ltz": "luksemburski",
		"dum": "średnioniderlandzki (ok. 1050-1350)",
		"mno": "manobo, języki",
		"wal": "wolayta",
		"sat": "santali",
		"szl": "śląski",
		"wak": "wakasz, języki",
		"bia": "Badimaya",
		"sas": "sasak",
		"kbd": "kabardyjski",
		"mni": "manipuri (meithei)",
		"san": "sanskryt",
		"sam": "samarytański",
		"dua": "duala",
		"sal": "salisz, języki",
		"mnc": "mandżurski",
		"sai": "Indian południowoamerykańskich (inne)",
		"kaz": "kazachski",
		"sah": "jakucki",
		"sag": "sango",
		"kaw": "kawi",
		"inh": "inguski",
		"gba": "gbaya",
		"sad": "sandawe",
		"kau": "kanuri",
		"kat": "gruziński",
		"ine": "indoeuropejskie (inne)",
		"bho": "bhodźpuri",
		"kas": "kaszmirski",
		"ind": "indonezyjski",
		"enm": "średnioangielski (1100-1500)",
		"kar": "kareńskie",
		"inc": "indoaryjskie (inne)",
		"tso": "tsonga",
		"tsn": "tswana",
		"ina": "interlingwa (Międzynarodowy Język Pomocniczy)",
		"gay": "gayo",
		"kan": "kannada",
		"kam": "kamba",
		"eng": "angielski",
		"anp": "angika",
		"syr": "syryjski",
		"umb": "umbundu",
		"kal": "kalaallisut (grenlandzki)",
		"tsi": "tsimshian",
		"end": "ende",
		"enc": "en",
		"ang": "staroangielski (ok. 450-1100)",
		"kac": "kachin",
		"cau": "kaukaskie (inne)",
		"kab": "kabylski",
		"cat": "kataloński",
		"kaa": "karakałpacki",
		"car": "carib",
		"syc": "syryjski klasyczny",
		"gaa": "ga",
		"cai": "Indian środkowoamerykańskich (inne)",
		"cad": "kaddoskie",
		"mlt": "maltański",
		"zen": "zenaga",
		"hsb": "górnołużycki",
		"pro": "staroprowansalski (do1500)",
		"amh": "amharski",
		"cym": "walijski",
		"au": "australijski",
		"ven": "venda",
		"dsb": "dolnołużycki",
		"mlg": "malgaski",
		"ilo": "ilokano",
		"elx": "elamicki",
		"hrv": "chorwacki",
		"ukr": "ukraiński",
		"pra": "prakryty",
		"new": "newarski",
		"qaa-qtz": "Zarezerwowane dla lokalnego użytku",
		"ile": "interlingwe (język sztuczny)",
		"ell": "grecki nowożytny (nowogrecki) (po 1453)",
		"alt": "ałtajski",
		"nep": "nepalski",
		"iku": "inuktitut",
		"alg": "algonkińskie (inne)",
		"ale": "aleucki",
		"mkh": "mon-khmerskie (inne)",
		"swe": "szwedzki",
		"dra": "drawidyjskie (inne)",
		"mkd": "macedoński",
		"swa": "suahili",
		"ber": "berberskie (inne)",
		"nds": "dolnoniemiecki",
		"ben": "bengalski",
		"bem": "bemba",
		"bel": "białoruski",
		"ndo": "ndonga",
		"bej": "bedża",
		"tpi": "neomelanezyjski (tok pisin)",
		"unknown": "nieznany"
	},
	"global": {
		"title": "Tytuł",
		"subject": "Temat",
		"language": "Język",
		"place_of_publishing": "Miejsce wydawania",
		"data_provider": "Dostawca danych",
		"issue_period": "Okres wydawania",
		"date_filter": "Zakres dat",
		"count": "Liczba numerów w FBC",
		"license": "Licencja",
		"publisher": "Wydawca",
		"keywords": "Słowa kluczowe",
		"show_FBC": "Pokaż w FBC",
		"button": {
			"submit": "Zatwierdź",
			"apply": "Zastosuj",
			"cancel": "Anuluj",
			"close": "Zamknij",
			"totop": "Powrót do góry"
		}
	},
	"header": {
		"contrast": "Zmień kontrast",
		"font": "Zmień rozmiar czcionki",
		"lang": "Zmień język",
		"logo": "Powrót na stronę główną"
	},
	"footer": {
		"text": {
			"first": "Serwis FBC Czasopisma utrzymywany jest przez",
			"second": "i jest usługą świadczoną w ramach sieci",
			"PSNC": {
				"full": "Poznańskie Centrum Superkomputerowo-Sieciowe",
				"short": "PCSS",
				"link": "http://www.man.poznan.pl/online/pl/"
			},
			"PIONIER": {
				"full": "Polski Internet Optyczny PIONIER",
				"short": "PIONIER",
				"link": "http://www.pionier.net.pl/online/pl/"
			}
		},
		"menu": {
			"link_1": {
				"title": "FBC",
				"link": "https://fbc.pionier.net.pl/"
			},
			"link_2": {
				"title": "Z kim współpracujemy",
				"link": "http://fbc.pionier.net.pl/pro/zrodla"
			},
			"link_3": {
				"title": "Przyłącz się do FBC",
				"link": "http://fbc.pionier.net.pl/pro/wspolpraca/dla-dostawcow-danych/"
			},
			"link_4": {
				"title": "FBC na Facebooku",
				"link": "https://www.facebook.com/FederacjaBibliotekCyfrowych"
			},
			"link_5": {
				"title": "Kontakt",
				"link": "http://fbc.pionier.net.pl/pro/kontakt/"
			}
		}
	},
	"cookies": {
		"bar": {
			"text": "Używamy plików cookies, by ułatwić korzystanie z naszych serwisów. Jeżeli nie chcesz, by pliki cookies były zapisywane na Twoim dysku, zmień ustawienia swojej przeglądarki.",
			"link": "Sprawdź informacje o plikach cookies i polityce prywatności."
		},
		"modal": {
			"title": "Pliki cookies na naszych stronach",
			"text": "<p>Cookies to małe pliki tekstowe zapisywane na komputerze Użytkownika lub innym urządzeniu mobilnym, w czasie korzystania przez niego ze stron internetowych. Pliki te służą m.in. korzystaniu z różnych funkcji przewidzianych na danej stronie Internetowej lub potwierdzeniu, że dany Użytkownik widział określone treści z danej witryny Internetowej.</p><p>Niniejszy serwis internetowy może używać plików \"cookies\", kiedy użytkownik odwiedza stronę www. Pliki \"cookies\", które mogą zostać użyte w witrynach i stronach internetowych są kojarzone wyłącznie z przeglądarką konkretnego komputera (użytkownik anonimowy), bez podawania imienia lub nazwiska użytkownika. Są to informacje zapisywane przez serwer usługi WWW na komputerze użytkownika, które tenże serwer może odczytać przy każdorazowym połączeniu się z komputera użytkownika.</p><p>Pliki \"cookies\" dostarczają danych statystycznych o ruchu użytkowników i korzystaniu przez nich z poszczególnych stron serwisu; w niektórych przypadkach ich użycie jest niezbędne do poprawnego funkcjonowania usług udostępnianych przez serwis internetowy.</p><p>Użytkownik może w każdym czasie wybrać sposób obsługi plików \"cookies\" w strefie internetowej poprzez zastąpienie automatycznej obsługi plików \"cookie\" na obsługę indywidualną (ustawienia użytkownika). Szczegółowych informacji w tym zakresie udzielają dostawcy programów do obsługi strefy internetowej (przeglądarek), zazwyczaj w zakładce \"opcje internetowe\" lub podobnej. Jednakże wyłączenie przez użytkownika w swojej przeglądarce opcji akceptowania plików \"cookies\", (zablokowanie, monitowanie) może spowodować utrudnienia czy wręcz uniemożliwić korzystanie z niektórych usług internetowych.</p><p>Jednocześnie informujemy, że właściciele serwisu nie ponoszą żadnej odpowiedzialności za stosowanie lub obsługę plików \"cookies\" na innych stronach internetowych dostępnych dla użytkowników poprzez linki umieszczone w naszym serwisie.</p><p>Więcej informacji o plikach cookies znajdziesz w serwisie <a href=\"http://wszystkoociasteczkach.pl\" target=\"_blank\">http://wszystkoociasteczkach.pl/</a>.</p><p><strong>Copyright © 2017 PCSS</strong></p>"
		}
	},
	"altimg": {
		"logo": "Logotyp FBC Czasopisma"
	}
};

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  /**
   * Catch window scroll event 
   * @return {void}
   */
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };

    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    };

    window.onscroll = catchScroll;
  },

  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Global_Cookies__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Global_Cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Global_Cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_directives_thousandNumberFormatDirective__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer_Footer___default.a,
    'cookies': __WEBPACK_IMPORTED_MODULE_2__components_Global_Cookies___default.a
  },
  directives: {
    thousandNumberFormat: __WEBPACK_IMPORTED_MODULE_3__scripts_directives_thousandNumberFormatDirective__["a" /* thousandNumberFormat */]
  },
  methods: {
    handleScroll: function handleScroll() {
      return this.$store.commit('SET_APP_SCROLL', window.scrollY > 400);
    },
    handleResize: function handleResize() {
      return this.$store.commit('SET_IS_MOBILE', window.innerWidth <= 767);
    }
  },
  created: function created() {
    if (this.$cookies.isKey('lang')) {
      this.$setLang(this.$cookies.get('lang'));
    }
    document.title = this.$lang.title;
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
    fontSize: 'GET_FONT_SIZE',
    isFiltersOpened: 'GET_IS_FILTER_BOX',
    isMobile: 'GET_IS_MOBILE'
  }))
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'error-404',

    created: function created() {
        window.location.href = this.error404Url;
    },

    computed: {
        error404Url: function error404Url() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().errorsUrl.error404;
        }
    }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'error-503',

    created: function created() {
        window.location.href = this.error503Url;
    },

    computed: {
        error503Url: function error503Url() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().errorsUrl.error503;
        }
    }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'checkLangCode',
    props: ['langCode'],
    methods: {
        checkLangCode: function checkLangCode(lang) {
            return this.$lang.langCode[lang] ? this.$lang.langCode[lang] : this.$lang.langCode['unknown'];
        }
    }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cookies',
  data: function data() {
    return {
      isAcceptCookies: false,

      isActiveCookieModal: false
    };
  },


  methods: {
    setAcceptCookies: function setAcceptCookies() {
      this.cookies = true;
      this.isAcceptCookies = true;
    },
    toggleCookieModal: function toggleCookieModal() {
      this.isActiveCookieModal = !this.isActiveCookieModal;
    }
  },

  created: function created() {
    this.isAcceptCookies = this.cookies;
  },


  computed: {
    cookies: {
      get: function get() {
        return this.$cookies.isKey('AcceptCookies');
      },
      set: function set(boolean) {
        return this.$cookies.set('AcceptCookies', boolean);
      }
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_items_per_page__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itemsPerPage',
  data: function data() {
    return {};
  },

  methods: {
    setActiveRow: function setActiveRow(n) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scripts_modules_items_per_page__["a" /* default */])(n);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loading: 'GET_LOADING_STATE',
    rowsNum: 'GET_ROWS_NUM',
    totalPagesNum: 'GET_TOTAL_PAGES_NUM',
    searchResultsNum: 'GET_SEARCH_RESULTS_NUM'
  }))
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pagination',
  methods: {
    isFirstPage: function isFirstPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["a" /* isFirstPage */]();
    },
    isLastPage: function isLastPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["b" /* isLastPage */]();
    },
    setPreviousPage: function setPreviousPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["c" /* setPreviousPage */]();
    },
    setNextPage: function setNextPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["d" /* setNextPage */]();
    },
    setActivePage: function setActivePage(n) {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["e" /* setActivePage */](n);
    },
    isDisplayed: function isDisplayed(n) {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["g" /* isDisplayed */](n);
    },
    isDisplayedEllipsis: function isDisplayedEllipsis(n) {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["h" /* isDisplayedEllipsis */](n);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loading: 'GET_LOADING_STATE',
    totalPagesNum: 'GET_TOTAL_PAGES_NUM',
    currentPage: 'GET_CURRENT_PAGE',
    appIsRunning: 'GET_APP_IS_RUNNING'
  }))
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'paginationWithInput',
  methods: {
    isFirstPage: function isFirstPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["a" /* isFirstPage */]();
    },
    isLastPage: function isLastPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["b" /* isLastPage */]();
    },
    setPreviousPage: function setPreviousPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["c" /* setPreviousPage */]();
    },
    setNextPage: function setNextPage() {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["d" /* setNextPage */]();
    },
    setActivePage: function setActivePage(n) {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["e" /* setActivePage */](n);
    },
    updateCurrentPage: function updateCurrentPage(event) {
      return __WEBPACK_IMPORTED_MODULE_1__scripts_modules_pagination__["f" /* updateCurrentPage */](event);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    loading: 'GET_LOADING_STATE',
    totalPagesNum: 'GET_TOTAL_PAGES_NUM',
    currentPage: 'GET_CURRENT_PAGE',
    appIsRunning: 'GET_APP_IS_RUNNING'
  }), {
    getCurrentPage: function getCurrentPage() {
      return this.appIsRunning ? this.currentPage : '';
    }
  })
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_sorting__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sort',
  data: function data() {
    return {};
  },

  methods: {
    sortResults: function sortResults(event) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scripts_modules_sorting__["a" /* default */])(event.target.value);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    sortingParam: 'GET_SORTING',
    loading: 'GET_LOADING_STATE'
  }), {
    sortParam: {
      get: function get() {
        return this.sortingParam;
      },
      set: function set(value) {
        return value;
      }
    }
  })
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  components: {
    'search-form': __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm___default.a
  },
  data: function data() {
    return {
      isActiveLang: false,
      isActiveFont: false,
      isFontSet: false
    };
  },

  methods: {
    toggleFont: function toggleFont() {
      this.isActiveFont = !this.isActiveFont;
    },
    setFont: function setFont(val) {
      this.$cookies.set('font', val);
      this.$store.commit('SET_FONT_SIZE', val);
      this.checkIfFontSet(val);
    },
    checkIfFontSet: function checkIfFontSet(val) {
      if (val == "medium" || val == "big") {
        this.isFontSet = true;
      } else {
        this.isFontSet = false;
      }
    },
    toggleLang: function toggleLang() {
      this.isActiveLang = !this.isActiveLang;
    },
    isActiveLangClass: function isActiveLangClass(lang) {
      return lang == this.$lang.language;
    },
    setLang: function setLang(lang) {
      this.$setLang(lang);

      this.$cookies.remove('lang');

      this.$cookies.set('lang', lang);
    }
  },
  created: function created() {
    var font = this.$cookies.get('font');
    if (font) {
      this.$store.commit('SET_FONT_SIZE', font);
    }
    this.checkIfFontSet(font);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    fontSize: 'GET_FONT_SIZE',
    fixed: 'GET_APP_SCROLL'
  }))
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_Header__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_Search__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Search_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error_503__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error_503___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Error_503__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_modules_url__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_modules_main_page__ = __webpack_require__(253);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-page',
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_2__Header_Header___default.a,
    'main-search': __WEBPACK_IMPORTED_MODULE_3__Search_Search___default.a,
    'error-503': __WEBPACK_IMPORTED_MODULE_4__Error_503___default.a
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App!'
    };
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_5__scripts_modules_url__["a" /* receiveUrl */](this.$route.query);
  },
  beforeUpdate: function beforeUpdate() {
    this.$router.push(__WEBPACK_IMPORTED_MODULE_5__scripts_modules_url__["b" /* dispatchUrl */]());
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_6__scripts_modules_main_page__["a" /* onload */]();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    loading: 'GET_LOADING_STATE',
    appScroll: 'GET_APP_SCROLL'
  }))
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search_SearchBlockMain__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search_SearchBlockMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Search_SearchBlockMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_SearchResults__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_SearchResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Search_SearchResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search_SearchInfo__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search_SearchInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Search_SearchInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Search_SearchFilters__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Search_SearchFilters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Search_SearchFilters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_Pagination__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Global_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Global_PaginationWithInput__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Global_PaginationWithInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Global_PaginationWithInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Global_ItemsPerPage__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Global_ItemsPerPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Global_ItemsPerPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Global_SortDropdown__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Global_SortDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Global_SortDropdown__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  components: {
    'search-block-main': __WEBPACK_IMPORTED_MODULE_2__Search_SearchBlockMain___default.a,
    'search-results': __WEBPACK_IMPORTED_MODULE_3__Search_SearchResults___default.a,
    'search-info': __WEBPACK_IMPORTED_MODULE_4__Search_SearchInfo___default.a,
    'search-filters': __WEBPACK_IMPORTED_MODULE_5__Search_SearchFilters___default.a,

    'pagination': __WEBPACK_IMPORTED_MODULE_6__Global_Pagination___default.a,
    'pagination-with-input': __WEBPACK_IMPORTED_MODULE_7__Global_PaginationWithInput___default.a,
    'sort-dropdown': __WEBPACK_IMPORTED_MODULE_9__Global_SortDropdown___default.a,
    'items-per-page': __WEBPACK_IMPORTED_MODULE_8__Global_ItemsPerPage___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    searchResultsList: 'GET_SEARCH_RESULTS_DOCS',
    fixed: 'GET_APP_SCROLL'
  }))
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'searchBlockMain',
    components: {
        'search-form': __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
        appScroll: 'GET_APP_SCROLL'
    }))
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_modules_search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filter',
  methods: {
    setOpened: function setOpened() {
      return !this.isOpened ? this.$store.commit('SET_FILTER_BOX', this.name) : this.$store.commit('SET_FILTER_BOX', false);
    },
    toggleOpened: function toggleOpened() {
      this.setOpened();
      return this.$store.commit('SET_IS_FILTER_BOX', this.isOpened);
    },
    setDateRange: function setDateRange() {
      if (this.fromValid && this.toValid) {
        __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["b" /* setDateRange */]();

        this.setOpened();

        this.$store.commit('RESET_DATE_ARR');
      }
    },
    resetDateRange: function resetDateRange() {
      this.clearDateFileds();
      __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["c" /* resetDateRange */]();
    },
    clearDateFileds: function clearDateFileds() {
      this.dateFrom = '';
      this.dateTo = '';

      __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["a" /* setValidDates */]();

      this.$store.commit('RESET_DATE_ARR');
    },
    setNewRange: function setNewRange(startDate, endDate, type, valueDefault) {
      if (!(type && valueDefault)) {
        __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["a" /* setValidDates */]();
      }

      if (this.fromValid && this.toValid) {
        this.dateFrom = startDate;
        this.dateTo = endDate;

        startDate = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["d" /* momentDateValid */](startDate);
        endDate = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["d" /* momentDateValid */](endDate);

        if (type && valueDefault) {
          if (type == 'from') {
            this.dateFrom = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["e" /* momentDateRangeValidDateFrom */](startDate, this.end, valueDefault);
            startDate = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["e" /* momentDateRangeValidDateFrom */](startDate, this.end, valueDefault);
          } else {
            this.dateTo = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["f" /* momentDateRangeValidDateTo */](this.start, endDate, valueDefault);
            endDate = __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["f" /* momentDateRangeValidDateTo */](this.start, endDate, valueDefault);
          }
        }

        if (__WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["g" /* momentCheckDateFromDateTo */](startDate, endDate)) {
          __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["h" /* setDateActive */](startDate, endDate);

          __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["i" /* setDateGap */](startDate, endDate);

          __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["j" /* setToArr */](startDate, endDate);

          __WEBPACK_IMPORTED_MODULE_2__scripts_modules_search__["d" /* loadDateRanges */]();
        }
      }
    },

    popFromDateArr: function popFromDateArr() {
      this.$store.commit('POP_FROM_DATE_ARR');
      __WEBPACK_IMPORTED_MODULE_2__scripts_modules_search__["d" /* loadDateRanges */]();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isOpened: {
      get: function get() {
        return this.$store.getters.GET_FILTER_BOX == this.name;
      },
      set: function set() {
        return false;
      }
    },
    dateFrom: {
      get: function get() {
        var value = this.$store.getters.GET_DATE_FROM;
        var date = value.split('-');
        date = date[2] + '.' + date[1] + '.' + date[0];
        return this.$store.getters.GET_VALID_DATE_FROM ? date : value;
      },
      set: function set(value) {
        var defaultValue = this.fromActive ? this.fromActive : this.start;
        this.$store.commit('SET_DATE_FROM', __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["k" /* isDate */](value, 'FROM', defaultValue));
      }
    },
    dateTo: {
      get: function get() {
        var value = this.$store.getters.GET_DATE_TO;
        var date = value.split('-');
        date = date[2] + '.' + date[1] + '.' + date[0];
        return this.$store.getters.GET_VALID_DATE_TO ? date : value;
      },
      set: function set(value) {
        var defaultValue = this.toActive ? this.toActive : this.end;
        this.$store.commit('SET_DATE_TO', __WEBPACK_IMPORTED_MODULE_1__scripts_modules_date_filter__["k" /* isDate */](value, 'TO', defaultValue));
      }
    },
    dateCount: {
      get: function get() {
        return this.$store.getters.GET_DATE_COUNT;
      }
    },
    isNewValue: function isNewValue() {
      return this.dateFrom == this.from && this.dateTo == this.to || !this.isDateSet && this.dateFrom == this.start && this.dateTo == this.end;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    from: 'GET_DATE_FROM_STATIC',
    to: 'GET_DATE_TO_STATIC',
    fromActive: 'GET_DATE_FROM_ACTIVE',
    toActive: 'GET_DATE_TO_ACTIVE',
    fromValid: 'GET_VALID_DATE_FROM',
    toValid: 'GET_VALID_DATE_TO',

    dateRanges: 'GET_FACET_DATE_RANGES',

    isDateSet: 'GET_IS_DATE_SET',
    dateValid: 'GET_IS_DATE_VALID',
    isDateCheck: 'GET_IS_DATE_CHECK',
    datePreviousValid: 'GET_IS_PREVIOUS_DATE_VALID',
    dateGap: 'GET_DATE_GAP',
    start: 'GET_DATE_START',
    end: 'GET_DATE_END',

    dateArr: 'GET_DATE_ARR'
  }))
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_modules_filter__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_reusable_group_array_elements__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_CheckLangCode__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Global_CheckLangCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Global_CheckLangCode__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filter',
  components: {
    'check-lang-code': __WEBPACK_IMPORTED_MODULE_3__Global_CheckLangCode___default.a
  },
  props: {
    name: {
      type: String
    },
    values: {
      type: Array
    }
  },
  data: function data() {
    return {
      checkedFiltersTmp: [],
      searchFilter: '',
      currentPage: 1,
      perPage: 20
    };
  },

  methods: {
    setOpened: function setOpened() {
      return !this.isOpened ? this.$store.commit('SET_FILTER_BOX', this.name) : this.$store.commit('SET_FILTER_BOX', false);
    },
    toggleOpened: function toggleOpened() {
      this.setOpened();
      return this.$store.commit('SET_IS_FILTER_BOX', this.isOpened);
    },
    setFilters: function setFilters() {
      __WEBPACK_IMPORTED_MODULE_1__scripts_modules_filter__["b" /* setFilters */](this.checkedFiltersTmp, this.name);

      this.unSelectAll();

      this.setOpened();
    },
    resetFilters: function resetFilters() {
      this.unSelectAll();

      __WEBPACK_IMPORTED_MODULE_1__scripts_modules_filter__["b" /* setFilters */](this.checkedFiltersTmp, this.name);
    },
    deleteFilter: function deleteFilter(value) {
      __WEBPACK_IMPORTED_MODULE_1__scripts_modules_filter__["b" /* setFilters */](this.checkedFiltersTmp.filter(function (item) {
        return item !== value;
      }), this.name);
    },
    selectAll: function selectAll() {
      var that = this;

      this.unSelectAll();

      this.filteredListTmp.forEach(function (value) {
        that.checkedFiltersTmp.push(value.name);
      });
    },

    unSelectAll: function unSelectAll() {
      this.checkedFiltersTmp = [];
    },

    setNextPage: function setNextPage() {
      if (this.currentPage < this.totalPagesNum) {
        this.currentPage += 1;
      }
    },

    setPrevPage: function setPrevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    updateCurrentPage: function updateCurrentPage(event) {
      var newVal = parseInt(event.target.value);
      if (newVal <= this.totalPagesNum && newVal >= 1) {
        this.currentPage = newVal;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.checkedFiltersTmp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.filterParam) !== ( true ? 'undefined' : _typeof(undefined)) ? this.filterParam.filters : [];
  },

  computed: {
    isOpened: {
      get: function get() {
        return this.$store.getters.GET_FILTER_BOX == this.name;
      },
      set: function set() {
        return false;
      }
    },
    newValues: function newValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__scripts_reusable_group_array_elements__["a" /* default */])(this.values);
    },
    filteredListTmp: function filteredListTmp() {
      var _this = this;

      var list = this.newValues.filter(function (subFilter) {
        var langCodeName = _this.$lang.langCode[subFilter.name];
        var langFullName = langCodeName ? langCodeName : 'none';
        return _this.name == 'language' ? langFullName.toLowerCase().includes(_this.searchFilter.toLowerCase()) : subFilter.name.toLowerCase().includes(_this.searchFilter.toLowerCase());
      });

      if (Math.ceil(list.length / this.perPage) < this.currentPage) {
        this.currentPage = 1;
      }
      return list;
    },
    filteredList: function filteredList() {
      return this.filteredListTmp.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    },
    filterParam: function filterParam() {
      return this.$store.getters.GET_FILTER_PARAMS_BY_NAME(this.name);
    },
    activeSubmit: function activeSubmit() {
      return !this.$store.getters.GET_FILTER_PARAMS_BY_NAME(this.name) ? this.checkedFiltersTmp.length == 0 : false;
    },
    totalPagesNum: function totalPagesNum() {
      return this.filteredListTmp.length > 0 ? Math.ceil(this.filteredListTmp.length / this.perPage) : 1;
    }
  },
  watch: {
    filterParam: function filterParam(val) {
      this.checkedFiltersTmp = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val)) !== ( true ? 'undefined' : _typeof(undefined)) ? val.filters : [];
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search_SearchFilter__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search_SearchFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Search_SearchFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_SearchDateFilter__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_SearchDateFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Search_SearchDateFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_modules_filter__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_modules_store_date_filters_setters__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_modules_date_filter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_modules_search__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filters',
  components: {
    'search-filter': __WEBPACK_IMPORTED_MODULE_2__Search_SearchFilter___default.a,
    'search-date-filter': __WEBPACK_IMPORTED_MODULE_3__Search_SearchDateFilter___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    toggleFilters: function toggleFilters() {
      return this.$store.commit('SET_IS_FILTER_BOX', !this.isActiveFilters);
    },
    resetFilters: function resetFilters() {
      __WEBPACK_IMPORTED_MODULE_4__scripts_modules_filter__["a" /* resetFilters */]();

      __WEBPACK_IMPORTED_MODULE_5__scripts_modules_store_date_filters_setters__["b" /* resetDateRange */]();

      __WEBPACK_IMPORTED_MODULE_6__scripts_modules_date_filter__["a" /* setValidDates */]();

      __WEBPACK_IMPORTED_MODULE_7__scripts_modules_search__["b" /* loadResultsWithDataPreload */]();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isActiveFilters: {
      get: function get() {
        return this.$store.getters.GET_IS_FILTER_BOX;
      }
    },
    isFiltersSet: {
      get: function get() {
        return this.$store.getters.GET_FILTER_PARAMS && this.$store.getters.GET_FILTER_PARAMS.length;
      }
    },
    isDateSet: {
      get: function get() {
        return this.$store.getters.GET_IS_DATE_SET;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    filtersFields: 'GET_FILTERS_FIELDS'
  }))
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_modules_url__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_modules_search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__ = __webpack_require__(251);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  watch: {
    'newSearchParamsKey': function newSearchParamsKey(newKey) {
      this.autocompleteGetSuggestions(this.newSearchParams);
      if (!this.activeSuggestions) {
        this.$store.commit('SET_ACTIVE_SUGGEST_TMP', newKey);
      }
    }
  },
  methods: {
    autocompleteGetSuggestions: _.debounce(function (params) {
      this.status = 'Typed';
      __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["a" /* getSuggestions */](this.$lang.search.form.select.params, params);
    }, 100),

    autocompleteHighlightLetters: function autocompleteHighlightLetters(suggestion, query) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["b" /* highlightLetters */](suggestion, query);
    },
    autocompleteSetSuggestion: function autocompleteSetSuggestion(value) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["c" /* setSuggestion */](this.newSearchParams, value);
    },
    autocompleteKeyHandler: function autocompleteKeyHandler(e) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["d" /* keyHandler */](e, this.$refs.autocompleteList);
    },
    autocompleteListMouseEnter: function autocompleteListMouseEnter(e) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["e" /* listMouseEnter */](e, this.$refs.autocompleteList);
    },
    autocompleteListMouseLeave: function autocompleteListMouseLeave(e) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["f" /* listMouseLeave */](e);
    },
    newSearchQuery: function newSearchQuery() {
      return __WEBPACK_IMPORTED_MODULE_4__scripts_modules_search__["f" /* newSearchQuery */](this.newSearchParams);
    },
    onClickOutside: function onClickOutside(event) {
      return __WEBPACK_IMPORTED_MODULE_5__scripts_modules_autocomplete__["g" /* setAutocompleteDropdown */](true);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    newSearchParamsKey: {
      get: function get() {
        return this.newSearchParams.key;
      },
      set: function set(value) {
        this.$store.commit('SET_NEW_SEARCH_PARAMS_KEY', value);
      }
    },
    newSearchParamsParam: {
      get: function get() {
        return this.newSearchParams.param;
      },
      set: function set(value) {
        this.$store.commit('SET_NEW_SEARCH_PARAMS_PARAM', value);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    newSearchParams: 'GET_NEW_SEARCH_PARAMS',
    suggestions: 'GET_SUGGESTIONS',
    activeSuggestTmp: 'GET_ACTIVE_SUGGEST_TMP',
    activeSuggestions: 'GET_IS_ACTIVE_SUGGESTIONS',
    activeAutocompleteDropdown: 'GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN'
  }))
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_modules_search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-info',
  methods: {
    getParamName: function getParamName(param) {
      param = (typeof param === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(param)) !== ( true ? 'undefined' : _typeof(undefined)) ? param : '';

      for (var i in this.$lang.search.form.select.params) {
        if (this.$lang.search.form.select.params[i]['val'] == param) {
          return this.$lang.search.form.select.params[i]['name'];
        }
      }
    },
    showAll: function showAll() {
      this.$store.commit('RESET_SEARCH_PARAMS_KEY');
      this.$store.commit('RESET_SEARCH_PARAMS_PARAM');
      __WEBPACK_IMPORTED_MODULE_3__scripts_modules_search__["e" /* resetSearchQuery */]();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    searchParams: 'GET_SEARCH_PARAMS',
    searchResultsNum: 'GET_SEARCH_RESULTS_NUM',
    appIsRunning: 'GET_APP_IS_RUNNING'
  }), {
    isAllSearch: function isAllSearch() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */])().params.search.default.key;
    }
  })
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_modules_search_results__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_Pagination__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Global_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Global_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global_ItemsPerPage__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global_ItemsPerPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Global_ItemsPerPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_CheckLangCode__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Global_CheckLangCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Global_CheckLangCode__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-results',
  components: {
    'pagination': __WEBPACK_IMPORTED_MODULE_4__Global_Pagination___default.a,
    'items-per-page': __WEBPACK_IMPORTED_MODULE_5__Global_ItemsPerPage___default.a,
    'check-lang-code': __WEBPACK_IMPORTED_MODULE_6__Global_CheckLangCode___default.a
  },
  methods: {
    brokenImgUrl: function brokenImgUrl(e) {
      e.target.src = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])().brokenImgUrl;
      e.target.parentElement.classList.add('item__picture--error');
    },

    fbcSearchQueryPrefix: function fbcSearchQueryPrefix() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])().FBC.path + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])().FBC.query.prefix;
    },
    fbcSearchQueryByTitle: function fbcSearchQueryByTitle(newspaperTitle) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_search_results__["a" /* default */])(newspaperTitle);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    searchResultsNum: 'GET_SEARCH_RESULTS_NUM',
    searchResultsList: 'GET_SEARCH_RESULTS_DOCS',
    totalPagesNum: 'GET_TOTAL_PAGES_NUM',
    currentPage: 'GET_CURRENT_PAGE',
    rowsNum: 'GET_ROWS_NUM',
    loading: 'GET_LOADING_STATE',
    sortingParam: 'GET_SORTING',
    dateFrom: 'GET_DATE_FROM',
    dateTo: 'GET_DATE_TO',
    isDateSet: 'GET_IS_DATE_SET'
  }))
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lang__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookies__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_click_outside__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_v_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_backtotop__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_checkbox_radio__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_checkbox_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_checkbox_radio__);














var locales = {
  'en': __webpack_require__(209),
  'pl': __webpack_require__(210)
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lang___default.a, { lang: 'pl', locales: locales });

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_click_outside___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_backtotop__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_checkbox_radio___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return thousandNumberFormat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);


var thousandNumberFormat = {
    bind: function bind(el, binding, vnode) {
        var langString = el.lang == "pl" ? " " : ".";
        el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, langString);
    },
    update: function update(el, binding, vnode) {
        var langString = el.lang == "pl" ? " " : ".";
        el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, langString);
    }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('thousand-number', thousandNumberFormat);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSuggestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return highlightLetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAutocompleteDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return listMouseEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return listMouseLeave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_autocompleteStore_getters__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_searchStore_setters__ = __webpack_require__(8);







var getSuggestions = function getSuggestions(langparam, params) {
    var arrayParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(langparam);
    var parameter = _arraySearchParam(arrayParams, params.param);

    if (!__WEBPACK_IMPORTED_MODULE_4__store_autocompleteStore_getters__["a" /* getIsActiveSuggestions */]()) {
        __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["b" /* loadSuggestions */]({ params: params, parameter: parameter });
    }
};

var setSuggestion = function setSuggestion(params, value) {
    var newParamsFromSuggestion = { key: value, param: params.param };
    __WEBPACK_IMPORTED_MODULE_5__store_searchStore_setters__["j" /* setNewSearchParamsKey */](value);
    __WEBPACK_IMPORTED_MODULE_2__search__["f" /* newSearchQuery */](newParamsFromSuggestion);
};

var highlightLetters = function highlightLetters(suggestion, query) {
    return suggestion.replace(query, '<span class=\'suggestion__highlight\'>' + query + '</span>');
};

var keyHandler = function keyHandler(e, list) {
    if ((e.keyCode == 40 || e.keyCode == 38) && list.length > 0) {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["c" /* setIsActiveSuggestions */](true);

        var inc = e.keyCode == 40 ? 1 : -1,
            moveOld = !__WEBPACK_IMPORTED_MODULE_4__store_autocompleteStore_getters__["b" /* getActiveMouse */]() ? _searchListActiveItem(list) : _mouseListActiveItem(),
            moveNew = parseInt(moveOld) + inc,
            firstUpDown = e.keyCode == 40 ? 0 : list.length - 1;

        if (moveOld && list[moveNew]) {
            list[moveOld].classList.remove('suggestion__active');
            list[moveNew].classList.add('suggestion__active');
            __WEBPACK_IMPORTED_MODULE_5__store_searchStore_setters__["j" /* setNewSearchParamsKey */](list[moveNew].text);
        } else {
            if (_searchListActiveItem(list)) {
                list[_searchListActiveItem(list)].classList.remove('suggestion__active');
            }

            list[firstUpDown].classList.add("suggestion__active");
            __WEBPACK_IMPORTED_MODULE_5__store_searchStore_setters__["j" /* setNewSearchParamsKey */](list[firstUpDown].text);
        }
    } else {
        __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["a" /* setIsActiveAutocompleteDropdown */](false);
        __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["c" /* setIsActiveSuggestions */](false);
    }
};

var setAutocompleteDropdown = function setAutocompleteDropdown(b) {
    __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["a" /* setIsActiveAutocompleteDropdown */](b);
};

var listMouseEnter = function listMouseEnter(e, list) {
    if (_searchListActiveItem(list)) {
        list[_searchListActiveItem(list)].classList.remove('suggestion__active');
    }

    __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["d" /* setActiveMouse */](e.target.dataset.autocomplete);
    e.target.classList.add('suggestion__active');
};

var listMouseLeave = function listMouseLeave(e) {
    e.target.classList.remove('suggestion__active');
};

var _mouseListActiveItem = function _mouseListActiveItem() {
    var number = __WEBPACK_IMPORTED_MODULE_4__store_autocompleteStore_getters__["b" /* getActiveMouse */]();
    __WEBPACK_IMPORTED_MODULE_3__store_autocompleteStore_setters__["d" /* setActiveMouse */]('');
    return number;
};

var _searchListActiveItem = function _searchListActiveItem(list) {
    for (var i in list) {
        if (list[i].classList.contains('suggestion__active')) {
            return i;
        }
    }
};

var _arraySearchParam = function _arraySearchParam(arr, val) {
    var index = void 0;

    for (var i in arr) {
        if (arr[i]['val'] == val) {
            index = i;
        }
    }

    return arr[index]['autocomplete'];
};



/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search__ = __webpack_require__(6);





var setActiveRow = function setActiveRow(n) {
  __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__["l" /* setRowsNum */](n);

  __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__["g" /* resetPageStart */]();
  __WEBPACK_IMPORTED_MODULE_1__search__["c" /* loadResults */]();
};

/* harmony default export */ __webpack_exports__["a"] = (setActiveRow);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(3);






var onload = function onload() {
  __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__["a" /* setNewSorting */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */])().params.search.default.sortOptionAll);

  if (__WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["b" /* getDateTo */]() != '' && __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["a" /* getDateFrom */]() != '') {
    __WEBPACK_IMPORTED_MODULE_2__search__["a" /* loadResultsWithDataPreloadAlt */]();
  } else {
    __WEBPACK_IMPORTED_MODULE_2__search__["b" /* loadResultsWithDataPreload */]();
  }
};



/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_modules_local_iso_string__ = __webpack_require__(57);





var escapeValue = function escapeValue(value) {
  var escaped = value.replace(/([^"\\]*(?:\\.[^"\\]*)*)"/g, '$1\\"');
  return '"' + escaped + '"';
};

var getFbcQuery = function getFbcQuery(newspaperTitle) {
  var dateFrom = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["g" /* getDateFromStatic */]();
  var dateTo = __WEBPACK_IMPORTED_MODULE_1__store_date_filters_getters__["h" /* getDateToStatic */]();

  var filters = __WEBPACK_IMPORTED_MODULE_2__store_filters_getters__["b" /* getFilterParamsStatic */]();
  var languages = [];
  var dataProvider = [];

  filters.forEach(function (elem) {
    if (elem.name == "language") {
      languages = elem.filters;
    }
    if (elem.name == "data_provider") {
      dataProvider = elem.filters;
    }
  });

  var queryString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.titleFilter + escapeValue(newspaperTitle);

  if (dateFrom != '' && dateTo != '') {
    dateFrom = new Date(dateFrom);
    dateTo = new Date(dateTo);

    dateFrom.setHours(0, 0, 0, 0);
    dateTo.setHours(23, 59, 59, 999);

    queryString += '&' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.fqPrefix;
    queryString += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.dateFilter;
    queryString += "[" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_local_iso_string__["a" /* default */])(dateFrom) + ' TO ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_local_iso_string__["a" /* default */])(dateTo) + "]";
  }

  if (languages.length > 0) {
    queryString += '&' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.fqPrefix + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.languageFilter;

    languages.forEach(function (elem, index) {
      queryString += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.languageFilters + elem;
      if (index < languages.length - 1) {
        queryString += ' OR ';
      }
    });
  }

  if (dataProvider.length > 0) {
    queryString += '&' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.fqPrefix + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.dataProviderFilter;

    dataProvider.forEach(function (elem, index) {
      queryString += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.dataProviderFilters + "\"" + elem + "\"";
      if (index < dataProvider.length - 1) {
        queryString += ' OR ';
      }
    });
  }

  queryString += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */])().FBC.query.sortBy;

  return queryString;
};

/* harmony default export */ __webpack_exports__["a"] = (getFbcQuery);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search__ = __webpack_require__(6);





var sortResults = function sortResults(n) {
  __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__["a" /* setNewSorting */](n);

  __WEBPACK_IMPORTED_MODULE_0__store_searchStore_setters__["g" /* resetPageStart */]();
  __WEBPACK_IMPORTED_MODULE_1__search__["c" /* loadResults */]();
};

/* harmony default export */ __webpack_exports__["a"] = (sortResults);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveMouse; });
/* unused harmony export getActiveSuggestTmp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIsActiveSuggestions; });
/* unused harmony export getIsActiveAutocompleteDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);


var getActiveMouse = function getActiveMouse() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_ACTIVE_MOUSE;
};

var getActiveSuggestTmp = function getActiveSuggestTmp() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_ACTIVE_SUGGEST_TMP;
};

var getIsActiveSuggestions = function getIsActiveSuggestions() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_IS_ACTIVE_SUGGESTIONS;
};

var getIsActiveAutocompleteDropdown = function getIsActiveAutocompleteDropdown() {
  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN;
};



/***/ }),
/* 257 */
/***/ (function(module, exports) {



/***/ }),
/* 258 */
/***/ (function(module, exports) {



/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });


var state = {
    appIsRunning: false,

    appScroll: false,
    isMobile: window.innerWidth <= 767,
    fontSize: 'default'
};

var getters = {
    GET_APP_IS_RUNNING: function GET_APP_IS_RUNNING(state) {
        return state.appIsRunning;
    },

    GET_APP_SCROLL: function GET_APP_SCROLL(state) {
        return state.appScroll;
    },

    GET_FONT_SIZE: function GET_FONT_SIZE(state) {
        return state.fontSize;
    },

    GET_IS_MOBILE: function GET_IS_MOBILE(state) {
        return state.isMobile;
    }
};

var mutations = {
    SET_APP_IS_RUNNING: function SET_APP_IS_RUNNING(state, value) {
        state.appIsRunning = value;
    },

    SET_APP_SCROLL: function SET_APP_SCROLL(state, value) {
        state.appScroll = value;
    },

    SET_FONT_SIZE: function SET_FONT_SIZE(state, value) {
        state.fontSize = value;
    },

    SET_IS_MOBILE: function SET_IS_MOBILE(state, value) {
        state.isMobile = value;
    }
};



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_modules_solr_helper__ = __webpack_require__(59);








var state = {
  suggests: [],
  activeMouse: '',
  activeSuggestTmp: '',
  activeSuggestions: false,
  activeAutocompleteDropdown: false
};

var getters = {
  GET_SUGGESTIONS: function GET_SUGGESTIONS(state) {
    return state.suggests;
  },

  GET_ACTIVE_MOUSE: function GET_ACTIVE_MOUSE(state) {
    return state.activeMouse;
  },

  GET_ACTIVE_SUGGEST_TMP: function GET_ACTIVE_SUGGEST_TMP(state) {
    return state.activeSuggestTmp;
  },

  GET_IS_ACTIVE_SUGGESTIONS: function GET_IS_ACTIVE_SUGGESTIONS(state) {
    return state.activeSuggestions;
  },

  GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN: function GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN(state) {
    return state.activeAutocompleteDropdown;
  }

};

var actions = {
  LOAD_SUGGESTIONS: function LOAD_SUGGESTIONS(_ref, params) {
    var commit = _ref.commit;


    var solrSearchQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])().solr.paths.API;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(solrSearchQuery + 'terms?terms.fl=' + params.parameter + '&terms.prefix=' + params.params.key + '&terms=true&terms.limit=10&wt=json').then(function (response) {
      var list = response.data.terms[params.parameter];

      var filteredList = list.filter(function (el, index) {
        return index % 2 === 0;
      });
      commit('SET_SUGGESTIONS', filteredList);
    });
  }
};

var mutations = {
  SET_SUGGESTIONS: function SET_SUGGESTIONS(state, data) {
    state.suggests = data;
  },
  SET_ACTIVE_MOUSE: function SET_ACTIVE_MOUSE(state, number) {
    state.activeMouse = number;
  },
  SET_ACTIVE_SUGGEST_TMP: function SET_ACTIVE_SUGGEST_TMP(state, value) {
    state.activeSuggestTmp = value;
  },
  SET_IS_ACTIVE_SUGGESTIONS: function SET_IS_ACTIVE_SUGGESTIONS(state, boolean) {
    state.activeSuggestions = boolean;
  },
  SET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN: function SET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN(state, boolean) {
    state.activeAutocompleteDropdown = boolean;
  },
  RESET_SUGGESTIONS: function RESET_SUGGESTIONS(state) {
    state.suggests = [];
  }
};



/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_reusable_format_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_group_date_ranges__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reusable_fq_parser__ = __webpack_require__(63);










var dataSearchDefault = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])().params.search.default;
var facetDefault = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])().solr.filters;

var state = {
  dateRange: {
    from: '',
    to: '',
    count: 0
  },
  dateRangeSet: {
    from: '',
    to: ''
  },
  dateRangeActive: {
    from: '',
    to: ''
  },
  dateValid: {
    from: true,
    to: true
  },

  dateArr: [],
  dateStart: '',
  dateEnd: '',
  isDateCheck: true,
  isDateSet: false,
  dateGap: facetDefault.facet_date_gap,
  facetDateRanges: []
};

var getters = {
  GET_DATE_FROM: function GET_DATE_FROM(state) {
    return state.dateRange.from;
  },
  GET_DATE_TO: function GET_DATE_TO(state) {
    return state.dateRange.to;
  },
  GET_DATE_COUNT: function GET_DATE_COUNT(state) {
    return state.dateRange.count;
  },
  GET_DATE_FROM_STATIC: function GET_DATE_FROM_STATIC(state) {
    return state.dateRangeSet.from;
  },
  GET_DATE_TO_STATIC: function GET_DATE_TO_STATIC(state) {
    return state.dateRangeSet.to;
  },
  GET_DATE_FROM_ACTIVE: function GET_DATE_FROM_ACTIVE(state) {
    return state.dateRangeActive.from;
  },
  GET_DATE_TO_ACTIVE: function GET_DATE_TO_ACTIVE(state) {
    return state.dateRangeActive.to;
  },
  GET_DATE_START: function GET_DATE_START(state) {
    return state.dateStart;
  },
  GET_DATE_END: function GET_DATE_END(state) {
    return state.dateEnd;
  },
  GET_IS_DATE_SET: function GET_IS_DATE_SET(state) {
    return state.isDateSet;
  },
  GET_IS_DATE_CHECK: function GET_IS_DATE_CHECK(state) {
    return state.isDateCheck;
  },
  GET_FACET_DATE_RANGES: function GET_FACET_DATE_RANGES(state) {
    return state.facetDateRanges;
  },
  GET_DATE_GAP: function GET_DATE_GAP(state) {
    return state.dateGap;
  },
  GET_DATE_ARR: function GET_DATE_ARR(state) {
    return state.dateArr;
  },
  GET_VALID_DATE_FROM: function GET_VALID_DATE_FROM(state) {
    return state.dateValid.from;
  },
  GET_VALID_DATE_TO: function GET_VALID_DATE_TO(state) {
    return state.dateValid.to;
  }
};

var actions = {};

var mutations = {
  SET_DATE_FROM: function SET_DATE_FROM(state, val) {
    state.dateRange.from = val;
  },

  SET_DATE_TO: function SET_DATE_TO(state, val) {
    state.dateRange.to = val;
  },

  SET_DATE_COUNT: function SET_DATE_COUNT(state, val) {
    state.dateRange.count = val;
  },

  SET_VALID_DATE_FROM: function SET_VALID_DATE_FROM(state, val) {
    state.dateValid.from = val;
  },
  SET_VALID_DATE_TO: function SET_VALID_DATE_TO(state, val) {
    state.dateValid.to = val;
  },

  SET_CHECK_DATE: function SET_CHECK_DATE(state, val) {
    state.isDateCheck = val;
  },

  SET_DATE_FROM_STATIC: function SET_DATE_FROM_STATIC(state, val) {
    state.dateRangeSet.from = val;
  },

  SET_DATE_TO_STATIC: function SET_DATE_TO_STATIC(state, val) {
    state.dateRangeSet.to = val;
  },

  SET_DATE_FROM_ACTIVE: function SET_DATE_FROM_ACTIVE(state, val) {
    state.dateRangeActive.from = val;
  },

  SET_DATE_TO_ACTIVE: function SET_DATE_TO_ACTIVE(state, val) {
    state.dateRangeActive.to = val;
  },

  SET_FACET_DATE_RANGES: function SET_FACET_DATE_RANGES(state, data) {
    state.facetDateRanges = __WEBPACK_IMPORTED_MODULE_3__reusable_group_date_ranges__["a" /* groupDateRanges */](data);
  },

  SET_TO_DATE_ARR: function SET_TO_DATE_ARR(state, val) {
    var dateStart = state.dateStart;
    var dateEnd = state.dateEnd;

    var dateArr = state.dateArr;

    var dateValueStart = val.start;
    var dateValueEnd = val.end;

    if (!(dateValueStart == dateStart && dateValueEnd == dateEnd) && (dateArr.length == 0 || dateArr.length > 0 && !(dateArr[dateArr.length - 1].start == val.start && dateArr[dateArr.length - 1].end == val.end))) {
      dateArr.push(val);
    }
  },

  RESET_DATE_ARR: function RESET_DATE_ARR(state, val) {
    state.dateArr = [];
  },

  POP_FROM_DATE_ARR: function POP_FROM_DATE_ARR(state, val) {
    state.dateArr.pop();

    if (state.dateArr.length > 0) {
      var obj = state.dateArr[state.dateArr.length - 1];
      state.dateRange.from = obj.start;
      state.dateRange.to = obj.end;
      state.dateRangeActive.from = obj.start;
      state.dateRangeActive.to = obj.end;
    } else {
      state.dateRange.from = state.dateRangeSet.from == '' ? state.dateStart : state.dateRangeSet.from;
      state.dateRange.to = state.dateRangeSet.to == '' ? state.dateEnd : state.dateRangeSet.to;
      state.dateRangeActive.from = state.dateRangeSet.from == '' ? state.dateStart : state.dateRangeSet.from;
      state.dateRangeActive.to = state.dateRangeSet.to == '' ? state.dateEnd : state.dateRangeSet.to;
    }
    state.dateGap = __WEBPACK_IMPORTED_MODULE_3__reusable_group_date_ranges__["b" /* setDateGap */]({ start: state.dateRange.from, end: state.dateRange.to });
  },

  RESET_DATE_RANGE: function RESET_DATE_RANGE(state) {
    state.dateRange.from = '';
    state.dateRange.to = '';
    state.dateRangeActive.from = '';
    state.dateRangeActive.to = '';
    state.isDateSet = false;
    state.dateGap = __WEBPACK_IMPORTED_MODULE_3__reusable_group_date_ranges__["b" /* setDateGap */]({ start: state.dateStart, end: state.dateEnd });
    state.dateArr = [];
  },

  SET_DATE_START: function SET_DATE_START(state, data) {
    state.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__scripts_reusable_format_date__["a" /* default */])(data.stats.stats_fields.date_start.min);
  },

  SET_DATE_END: function SET_DATE_END(state, data) {
    state.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__scripts_reusable_format_date__["a" /* default */])(data.stats.stats_fields.date_end.max);
  },

  SET_DATE_GAP: function SET_DATE_GAP(state, data) {
    state.dateGap = __WEBPACK_IMPORTED_MODULE_3__reusable_group_date_ranges__["b" /* setDateGap */](data);
  },

  SET_DATE_RANGE_RES: function SET_DATE_RANGE_RES(state, data) {
    var fq = data.responseHeader.params.fq;

    state.dateRange.from = state.dateStart;
    state.dateRange.to = state.dateEnd;

    state.dateRangeSet.from = '';
    state.dateRangeSet.to = '';

    state.isDateSet = false;

    function setFilter(value) {
      var name = __WEBPACK_IMPORTED_MODULE_4__reusable_fq_parser__["a" /* parseResStringName */](value);
      if (name == 'date') {
        var obj = __WEBPACK_IMPORTED_MODULE_4__reusable_fq_parser__["b" /* parseStringDate */](value, name);

        state.dateRange.from = obj.from;
        state.dateRange.to = obj.to;

        state.dateRangeSet.from = obj.from;
        state.dateRangeSet.to = obj.to;

        if (!state.isDateSet) {
          state.isDateSet = true;
        }
      }
    }

    if ((typeof fq === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fq)) !== ( true ? 'undefined' : _typeof(undefined))) {
      if (typeof fq !== 'string') {
        fq.forEach(function (value) {
          setFilter(value);
        });
      } else {
        setFilter(fq);
      }
    }
  }
};



/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_fq_parser__ = __webpack_require__(63);






var dataSearchDefault = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */])().params.search.default;

var state = {
  filters: {
    fields: {}
  },
  filterParams: [],
  filterParamsStatic: [],
  filterBox: false,
  isFilterBoxSet: false
};

var getters = {
  GET_FILTER_BOX: function GET_FILTER_BOX(state) {
    return state.filterBox;
  },
  GET_IS_FILTER_BOX: function GET_IS_FILTER_BOX(state) {
    return state.isFilterBoxSet;
  },
  GET_FILTERS_FIELDS: function GET_FILTERS_FIELDS(state) {
    return state.filters.fields;
  },
  GET_FILTER_PARAMS: function GET_FILTER_PARAMS(state) {
    return state.filterParams;
  },
  GET_FILTER_PARAMS_STATIC: function GET_FILTER_PARAMS_STATIC(state) {
    return state.filterParamsStatic;
  },
  GET_FILTER_PARAMS_BY_NAME: function GET_FILTER_PARAMS_BY_NAME(state) {
    return function (name) {
      return state.filterParams.filter(function (obj) {
        return obj.name == name;
      })[0];
    };
  }
};

var actions = {};

var mutations = {
  SET_FILTERS: function SET_FILTERS(state, _ref) {
    var list = _ref.list;

    state.filters.fields = list.facet_fields;
  },

  SET_FILTER_PARAMS: function SET_FILTER_PARAMS(state, obj) {
    state.filterParams.forEach(function (value) {
      if (value.name == obj.name) {
        var index = state.filterParams.findIndex(function (i) {
          return i.name === value.name;
        });

        state.filterParams.splice(index, 1);
      }
    });

    if (obj.filters.length > 0) {
      state.filterParams.push(obj);
    }
  },

  SET_FILTER_BOX: function SET_FILTER_BOX(state, box) {
    state.filterBox = box;
  },

  SET_IS_FILTER_BOX: function SET_IS_FILTER_BOX(state, box) {
    state.isFilterBoxSet = box;
  },

  RESET_FILTER_PARAMS: function RESET_FILTER_PARAMS(state) {
    state.filterParams = [];
    state.filterParamsStatic = [];
  },

  SET_FILTER_PARAMS_RES: function SET_FILTER_PARAMS_RES(state, data) {
    state.filterParams = [];
    state.filterParamsStatic = [];

    var fq = data.responseHeader.params.fq;

    function pushFilter(value) {
      var name = __WEBPACK_IMPORTED_MODULE_2__reusable_fq_parser__["a" /* parseResStringName */](value);
      if (name != 'date') {
        var obj = __WEBPACK_IMPORTED_MODULE_2__reusable_fq_parser__["c" /* parseResString */](value, name);
        state.filterParams.push(obj);
        state.filterParamsStatic.push(obj);
      }
    }

    if ((typeof fq === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fq)) !== ( true ? 'undefined' : _typeof(undefined))) {
      if (typeof fq !== 'string') {
        fq.forEach(function (value) {
          pushFilter(value);
        });
      } else {
        pushFilter(fq);
      }
    }
  }
};



/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_modules_solr_helper__ = __webpack_require__(59);









var dataSearchDefault = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */])().params.search.default;

var state = {
  searchParams: {
    key: dataSearchDefault.key,
    param: dataSearchDefault.param,
    start: dataSearchDefault.start,
    rows: dataSearchDefault.itemsPerPage,
    sorting: dataSearchDefault.sortOption
  },
  newSearchParams: {
    key: '',
    param: ''
  },

  pageParams: {
    currentPage: dataSearchDefault.pageStart,
    totalPages: 1
  },

  results: {
    response: {
      docs: {},
      numFound: 0,
      start: 0
    }
  },

  loading: {
    state: false,
    error: false
  }
};

var getters = {
  GET_SEARCH_PARAMS: function GET_SEARCH_PARAMS(state) {
    return state.searchParams;
  },
  GET_NEW_SEARCH_PARAMS: function GET_NEW_SEARCH_PARAMS(state) {
    return state.newSearchParams;
  },
  GET_SEARCH_RESULTS_DOCS: function GET_SEARCH_RESULTS_DOCS(state) {
    return state.results.response.docs;
  },
  GET_SEARCH_RESULTS_NUM: function GET_SEARCH_RESULTS_NUM(state) {
    return state.results.response.numFound;
  },
  GET_ROWS_NUM: function GET_ROWS_NUM(state) {
    return state.searchParams.rows;
  },
  GET_TOTAL_PAGES_NUM: function GET_TOTAL_PAGES_NUM(state) {
    return state.pageParams.totalPages;
  },
  GET_CURRENT_PAGE: function GET_CURRENT_PAGE(state) {
    return state.pageParams.currentPage;
  },
  GET_LOADING_STATE: function GET_LOADING_STATE(state) {
    return state.loading;
  },
  GET_SORTING: function GET_SORTING(state) {
    return state.searchParams.sorting;
  }
};

var actions = {
  LOAD_SEARCH_RESULTS: function LOAD_SEARCH_RESULTS(_ref) {
    var commit = _ref.commit;

    var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_solr_helper__["a" /* default */])();

    if (!state.loading.state) {
      commit('SET_LOADING_STATE', { loadingState: { state: true, error: false } });
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(path).then(function (response) {
      commit('SET_RESULTS', { list: response.data });
      commit('SET_ROWS_NUM');
      commit('SET_TOTAL_PAGES_NUM');
      commit('SET_CURRENT_PAGE');
      commit('SET_SORTING');

      commit('SET_FILTERS', { list: response.data.facet_counts });
      commit('SET_FILTER_PARAMS_RES', response.data);

      commit('SET_FACET_DATE_RANGES', response.data.facet_counts.facet_ranges.date);
      commit('SET_DATE_COUNT', response.data.response.numFound);

      commit('SET_APP_IS_RUNNING', true);

      commit('SET_LOADING_STATE', { loadingState: { state: false, error: false } });
    }, function (err) {
      commit('SET_LOADING_STATE', { loadingState: { state: false, error: true } });
    });
  },

  LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD: function LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD(_ref2) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit,
        rootState = _ref2.rootState;

    var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_solr_helper__["a" /* default */])();

    commit('SET_LOADING_STATE', { loadingState: { state: true, error: false } });

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(path).then(function (response) {
      commit('SET_DATE_START', response.data);
      commit('SET_DATE_END', response.data);
      commit('SET_DATE_FROM', rootState.dateFilters.dateStart);
      commit('SET_DATE_TO', rootState.dateFilters.dateEnd);

      commit('SET_DATE_GAP', { start: rootState.dateFilters.dateStart, end: rootState.dateFilters.dateEnd });

      dispatch('LOAD_SEARCH_RESULTS');
    });
  },

  LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD_ALT: function LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD_ALT(_ref3) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit,
        rootState = _ref3.rootState;

    var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_solr_helper__["a" /* default */])();

    commit('SET_LOADING_STATE', { loadingState: { state: true, error: false } });

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(path).then(function (response) {
      commit('SET_DATE_START', response.data);
      commit('SET_DATE_END', response.data);
      commit('SET_DATE_FROM', rootState.dateFilters.dateRangeSet.from);
      commit('SET_DATE_TO', rootState.dateFilters.dateRangeSet.to);

      commit('SET_DATE_GAP', { start: rootState.dateFilters.dateRangeSet.from, end: rootState.dateFilters.dateRangeSet.to });

      dispatch('LOAD_SEARCH_RESULTS');
    });
  },

  LOAD_DATE_RANGES: function LOAD_DATE_RANGES(_ref4) {
    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__scripts_modules_solr_helper__["a" /* default */])();
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(path).then(function (response) {
      commit('SET_FACET_DATE_RANGES', response.data.facet_counts.facet_ranges.date);
      commit('SET_DATE_COUNT', response.data.response.numFound);
    });
  }
};

var mutations = {
  SET_SEARCH_PARAMS: function SET_SEARCH_PARAMS(state, elem) {
    state.searchParams.key = elem.key;
    state.searchParams.param = elem.param;
  },

  SET_NEW_SEARCH_PARAMS_KEY: function SET_NEW_SEARCH_PARAMS_KEY(state, key) {
    state.newSearchParams.key = key;
  },

  SET_NEW_SEARCH_PARAMS_PARAM: function SET_NEW_SEARCH_PARAMS_PARAM(state, param) {
    state.newSearchParams.param = param;
  },

  RESET_SEARCH_PARAMS_KEY: function RESET_SEARCH_PARAMS_KEY(state) {
    state.searchParams.key = dataSearchDefault.key;
    state.newSearchParams.key = '';
  },

  RESET_SEARCH_PARAMS_PARAM: function RESET_SEARCH_PARAMS_PARAM(state) {
    state.searchParams.param = dataSearchDefault.param;
    state.newSearchParams.param = dataSearchDefault.param;
  },

  SET_NEW_START: function SET_NEW_START(state, n) {
    state.searchParams.start = (n - 1) * state.searchParams.rows;
  },

  SET_ROWS_NUM: function SET_ROWS_NUM(state, n) {
    var rows = n ? n : parseInt(state.results.responseHeader.params.rows);

    state.searchParams.rows = rows;
  },

  SET_RESULTS: function SET_RESULTS(state, _ref5) {
    var list = _ref5.list;

    state.results = list;
  },

  SET_TOTAL_PAGES_NUM: function SET_TOTAL_PAGES_NUM(state) {
    state.pageParams.totalPages = Math.ceil(parseInt(state.results.response.numFound) / state.searchParams.rows);
  },

  SET_CURRENT_PAGE: function SET_CURRENT_PAGE(state, n) {
    var currentPage = n ? n : Math.floor(parseInt(state.results.response.start) / state.searchParams.rows) + 1;

    state.pageParams.currentPage = currentPage;
  },

  SET_NEW_SORTING: function SET_NEW_SORTING(state, n) {
    if ((typeof n === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n)) != ( true ? 'undefined' : _typeof(undefined))) {
      state.searchParams.sorting = n;
    } else {
      state.searchParams.sorting = '';
    }
  },

  SET_SORTING: function SET_SORTING(state) {
    var sorting = encodeURIComponent(state.results.responseHeader.params.sort);

    if ((typeof soritng === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(soritng)) != ( true ? 'undefined' : _typeof(undefined))) {
      state.searchParams.sorting = sorting;
    }
  },

  SET_LOADING_STATE: function SET_LOADING_STATE(state, _ref6) {
    var loadingState = _ref6.loadingState;

    state.loading = loadingState;
  }
};



/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_modules_store_date_filters_setters__ = __webpack_require__(14);


var dateFilterPlugin = function dateFilterPlugin(store) {
  store.subscribe(function (mutation, state) {
    if (mutation.type === 'SET_FILTER_PARAMS_RES') {
      __WEBPACK_IMPORTED_MODULE_0__scripts_modules_store_date_filters_setters__["a" /* setDateRangeFromRes */](mutation.payload);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (dateFilterPlugin);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return groupDateRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setDateGap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_reusable_group_array_elements__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_reusable_format_date__ = __webpack_require__(21);





var chunk = __webpack_require__(270);

var groupDateRanges = function groupDateRanges(arr) {
  var start = arr.start.substring(0, arr.start.indexOf('T'));
  var end = arr.end.substring(0, arr.end.indexOf('T'));
  var arrGrouped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__scripts_reusable_group_array_elements__["a" /* default */])(arr.counts);
  var isEmpty = true;

  arrGrouped.forEach(function (obj) {
    if (obj.results > 0) {
      isEmpty = false;
    }
  });

  var arrIntervals = arrGrouped.length > 1 && !isEmpty ? chunk(start, end, 10) : chunk(start, end, 1);

  arrIntervals.forEach(function (value) {
    value.results = 0;

    if (arrGrouped.length > 1) {
      arrGrouped.forEach(function (obj) {
        var date = new Date(obj.name);
        if (date >= value.start && date < value.end) {
          value.results += obj.results;
        }
      });
    } else {
      value.results = arrGrouped[0].results;
    }

    value.start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scripts_reusable_format_date__["a" /* default */])(value.start);
    value.end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scripts_reusable_format_date__["a" /* default */])(value.end);
  });

  return arrIntervals;
};

var setDateGap = function setDateGap(data) {
  var start = new Date(data.start);
  var end = new Date(data.end);
  var timeDiff = Math.abs(end.getTime() - start.getTime());
  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

  var gap = diffDays >= 10 ? Math.ceil(diffDays / 10) : diffDays;
  gap = gap > 0 ? gap : 1;
  return gap;
};



/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 78,
	"./af.js": 78,
	"./ar": 85,
	"./ar-dz": 79,
	"./ar-dz.js": 79,
	"./ar-kw": 80,
	"./ar-kw.js": 80,
	"./ar-ly": 81,
	"./ar-ly.js": 81,
	"./ar-ma": 82,
	"./ar-ma.js": 82,
	"./ar-sa": 83,
	"./ar-sa.js": 83,
	"./ar-tn": 84,
	"./ar-tn.js": 84,
	"./ar.js": 85,
	"./az": 86,
	"./az.js": 86,
	"./be": 87,
	"./be.js": 87,
	"./bg": 88,
	"./bg.js": 88,
	"./bn": 89,
	"./bn.js": 89,
	"./bo": 90,
	"./bo.js": 90,
	"./br": 91,
	"./br.js": 91,
	"./bs": 92,
	"./bs.js": 92,
	"./ca": 93,
	"./ca.js": 93,
	"./cs": 94,
	"./cs.js": 94,
	"./cv": 95,
	"./cv.js": 95,
	"./cy": 96,
	"./cy.js": 96,
	"./da": 97,
	"./da.js": 97,
	"./de": 100,
	"./de-at": 98,
	"./de-at.js": 98,
	"./de-ch": 99,
	"./de-ch.js": 99,
	"./de.js": 100,
	"./dv": 101,
	"./dv.js": 101,
	"./el": 102,
	"./el.js": 102,
	"./en-au": 103,
	"./en-au.js": 103,
	"./en-ca": 104,
	"./en-ca.js": 104,
	"./en-gb": 105,
	"./en-gb.js": 105,
	"./en-ie": 106,
	"./en-ie.js": 106,
	"./en-nz": 107,
	"./en-nz.js": 107,
	"./eo": 108,
	"./eo.js": 108,
	"./es": 110,
	"./es-do": 109,
	"./es-do.js": 109,
	"./es.js": 110,
	"./et": 111,
	"./et.js": 111,
	"./eu": 112,
	"./eu.js": 112,
	"./fa": 113,
	"./fa.js": 113,
	"./fi": 114,
	"./fi.js": 114,
	"./fo": 115,
	"./fo.js": 115,
	"./fr": 118,
	"./fr-ca": 116,
	"./fr-ca.js": 116,
	"./fr-ch": 117,
	"./fr-ch.js": 117,
	"./fr.js": 118,
	"./fy": 119,
	"./fy.js": 119,
	"./gd": 120,
	"./gd.js": 120,
	"./gl": 121,
	"./gl.js": 121,
	"./gom-latn": 122,
	"./gom-latn.js": 122,
	"./he": 123,
	"./he.js": 123,
	"./hi": 124,
	"./hi.js": 124,
	"./hr": 125,
	"./hr.js": 125,
	"./hu": 126,
	"./hu.js": 126,
	"./hy-am": 127,
	"./hy-am.js": 127,
	"./id": 128,
	"./id.js": 128,
	"./is": 129,
	"./is.js": 129,
	"./it": 130,
	"./it.js": 130,
	"./ja": 131,
	"./ja.js": 131,
	"./jv": 132,
	"./jv.js": 132,
	"./ka": 133,
	"./ka.js": 133,
	"./kk": 134,
	"./kk.js": 134,
	"./km": 135,
	"./km.js": 135,
	"./kn": 136,
	"./kn.js": 136,
	"./ko": 137,
	"./ko.js": 137,
	"./ky": 138,
	"./ky.js": 138,
	"./lb": 139,
	"./lb.js": 139,
	"./lo": 140,
	"./lo.js": 140,
	"./lt": 141,
	"./lt.js": 141,
	"./lv": 142,
	"./lv.js": 142,
	"./me": 143,
	"./me.js": 143,
	"./mi": 144,
	"./mi.js": 144,
	"./mk": 145,
	"./mk.js": 145,
	"./ml": 146,
	"./ml.js": 146,
	"./mr": 147,
	"./mr.js": 147,
	"./ms": 149,
	"./ms-my": 148,
	"./ms-my.js": 148,
	"./ms.js": 149,
	"./my": 150,
	"./my.js": 150,
	"./nb": 151,
	"./nb.js": 151,
	"./ne": 152,
	"./ne.js": 152,
	"./nl": 154,
	"./nl-be": 153,
	"./nl-be.js": 153,
	"./nl.js": 154,
	"./nn": 155,
	"./nn.js": 155,
	"./pa-in": 156,
	"./pa-in.js": 156,
	"./pl": 157,
	"./pl.js": 157,
	"./pt": 159,
	"./pt-br": 158,
	"./pt-br.js": 158,
	"./pt.js": 159,
	"./ro": 160,
	"./ro.js": 160,
	"./ru": 161,
	"./ru.js": 161,
	"./sd": 162,
	"./sd.js": 162,
	"./se": 163,
	"./se.js": 163,
	"./si": 164,
	"./si.js": 164,
	"./sk": 165,
	"./sk.js": 165,
	"./sl": 166,
	"./sl.js": 166,
	"./sq": 167,
	"./sq.js": 167,
	"./sr": 169,
	"./sr-cyrl": 168,
	"./sr-cyrl.js": 168,
	"./sr.js": 169,
	"./ss": 170,
	"./ss.js": 170,
	"./sv": 171,
	"./sv.js": 171,
	"./sw": 172,
	"./sw.js": 172,
	"./ta": 173,
	"./ta.js": 173,
	"./te": 174,
	"./te.js": 174,
	"./tet": 175,
	"./tet.js": 175,
	"./th": 176,
	"./th.js": 176,
	"./tl-ph": 177,
	"./tl-ph.js": 177,
	"./tlh": 178,
	"./tlh.js": 178,
	"./tr": 179,
	"./tr.js": 179,
	"./tzl": 180,
	"./tzl.js": 180,
	"./tzm": 182,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 182,
	"./uk": 183,
	"./uk.js": 183,
	"./ur": 184,
	"./ur.js": 184,
	"./uz": 186,
	"./uz-latn": 185,
	"./uz-latn.js": 185,
	"./uz.js": 186,
	"./vi": 187,
	"./vi.js": 187,
	"./x-pseudo": 188,
	"./x-pseudo.js": 188,
	"./yo": 189,
	"./yo.js": 189,
	"./zh-cn": 190,
	"./zh-cn.js": 190,
	"./zh-hk": 191,
	"./zh-hk.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;

/***/ }),
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(338),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(343),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(344),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(340),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(335),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(337),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(346),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(347),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(341),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(329),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(334),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-info"
  }, [(_vm.searchParams.key != _vm.isAllSearch) ? _c('span', {
    staticClass: "search-info__text"
  }, [_vm._v("\n          " + _vm._s(_vm.getParamName(_vm.searchParams.param)) + ": "), _c('strong', [_vm._v(_vm._s(_vm.searchParams.key))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "search-info__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.search.info.count) + ": "), (_vm.appIsRunning) ? _c('strong', {
    directives: [{
      name: "thousand-number",
      rawName: "v-thousand-number",
      value: (_vm.searchResultsNum),
      expression: "searchResultsNum"
    }],
    attrs: {
      "lang": _vm.$lang.language
    }
  }, [_vm._v(_vm._s(_vm.searchResultsNum))]) : _vm._e()])]), _vm._v(" "), (_vm.searchParams.key != _vm.isAllSearch) ? _c('div', {
    staticClass: "is-clearfix"
  }, [_c('a', {
    staticClass: "search-info__all is-pulled-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.search.info.clear))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n    " + _vm._s(_vm.checkLangCode(_vm.langCode)) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.newSearchQuery($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "search-form__box search-form__box--select"
  }, [_c('span', {
    staticClass: "select select--search"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSearchParamsParam),
      expression: "newSearchParamsParam"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newSearchParamsParam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$lang.search.form.select.params), function(param) {
    return _c('option', {
      domProps: {
        "value": param.val
      }
    }, [_vm._v(_vm._s(param.name))])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "search-form__box search-form__box--input suggestion"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSearchParamsKey),
      expression: "newSearchParamsKey"
    }],
    staticClass: "input--search",
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang.search.form.input.placeholder
    },
    domProps: {
      "value": (_vm.newSearchParamsKey)
    },
    on: {
      "keydown": _vm.autocompleteKeyHandler,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSearchParamsKey = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.suggestions && _vm.suggestions.length > 0 && !_vm.activeAutocompleteDropdown && _vm.newSearchParamsKey) ? _c('ul', {
    staticClass: "suggestions__list"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('li', {
      staticClass: "suggestions__list--item suggestion"
    }, [_c('a', {
      ref: "autocompleteList",
      refInFor: true,
      staticClass: "suggestion__anchor",
      attrs: {
        "data-autocomplete": index
      },
      domProps: {
        "innerHTML": _vm._s(_vm.autocompleteHighlightLetters(suggestion, _vm.activeSuggestTmp))
      },
      on: {
        "click": function($event) {
          _vm.autocompleteSetSuggestion(suggestion)
        },
        "mouseenter": function($event) {
          _vm.autocompleteListMouseEnter($event)
        },
        "mouseleave": function($event) {
          _vm.autocompleteListMouseLeave($event)
        }
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search-form__box search-form__box--button"
  }, [_c('button', {
    staticClass: "button--search",
    attrs: {
      "type": "submit",
      "disabled": !_vm.newSearchParamsKey,
      "title": _vm.$lang.search.form.button.search
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/search.svg"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination__bottom"
  }, [_c('a', {
    staticClass: "pagination__bottom--prev",
    attrs: {
      "href": "",
      "disabled": _vm.isFirstPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.prev_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-left pagination__bottom--prev-arrow",
    attrs: {
      "data-v-704e50d2": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.pagination.prev))])]), _vm._v(" "), _c('a', {
    staticClass: "pagination__bottom--next",
    attrs: {
      "href": "",
      "disabled": _vm.isLastPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.next_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNextPage()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.pagination.next))]), _vm._v(" "), _c('i', {
    staticClass: "onp-chevron-right pagination__bottom--next-arrow",
    attrs: {
      "data-v-704e50d2": "",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.appIsRunning) ? _c('ul', {
    staticClass: "pagination__bottom--list"
  }, _vm._l((_vm.totalPagesNum), function(n) {
    return _c('li', [(_vm.isDisplayed(n)) ? _c('a', {
      staticClass: "pagination__bottom--list-link",
      class: [{
        'is-current': _vm.currentPage == n
      }],
      attrs: {
        "href": "",
        "disabled": _vm.loading.state,
        "title": n
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActivePage(n)
        }
      }
    }, [_vm._v(" " + _vm._s(n) + " ")]) : (_vm.isDisplayedEllipsis(n)) ? _c('span', {
      staticClass: "pagination__bottom--list-span"
    }, [_vm._v("…")]) : _vm._e()])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "items-per-page",
    class: [{
      'disabled': _vm.loading.state
    }]
  }, [_vm._l((_vm.$lang.items_per_page.elems), function(elem) {
    return _c('a', {
      staticClass: "items-per-page__button",
      class: [{
        'active': _vm.rowsNum == elem.val
      }],
      attrs: {
        "href": "",
        "title": elem.name
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveRow(elem.val)
        }
      }
    }, [_vm._v("\n        " + _vm._s(elem.val) + "\n  ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "items-per-page__text"
  }, [_vm._v(_vm._s(_vm.$lang.items_per_page.label))])], 2)
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('article', [(_vm.loading.state) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading__box"
  }, _vm._l((12), function(n) {
    return _c('div', {
      staticClass: "loading__circle"
    })
  }))]) : (_vm.searchResultsList.length != 0) ? _c('ul', _vm._l((_vm.searchResultsList), function(result) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "id": result.id
      }
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('h3', {
      staticClass: "item__header--title"
    }, [_c('i', {
      staticClass: "item__header--icon onp-newspaper"
    }), _vm._v(" " + _vm._s(result.newspaper_title))])]), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__picture"
    }, [_c('figure', {
      staticClass: "item__picture--figure"
    }, [_c('img', {
      staticClass: "item__picture--image",
      attrs: {
        "src": result.thumbnail_url,
        "alt": "Image"
      },
      on: {
        "error": function($event) {
          _vm.brokenImgUrl($event)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox"
    }, [_c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.language) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.language), function(lang) {
      return _c('span', [_c('strong', [_c('check-lang-code', {
        attrs: {
          "langCode": lang
        }
      })], 1)])
    }))]), _vm._v(" "), (result.subject) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.subject) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.subject), function(subject) {
      return _c('span', [_vm._v(_vm._s(subject))])
    }))]) : _vm._e(), _vm._v(" "), (result.publisher) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.publisher) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.publisher), function(publisher) {
      return _c('span', [_c('strong', [_vm._v(_vm._s(publisher))])])
    }))]) : _vm._e(), _vm._v(" "), (result.place_of_publishing) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.place_of_publishing) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.place_of_publishing), function(place_of_publishing) {
      return _c('span', [_vm._v(_vm._s(place_of_publishing))])
    }))]) : _vm._e(), _vm._v(" "), (result.data_provider) ? _c('div', {
      staticClass: "item__infobox--row"
    }, [_c('div', {
      staticClass: "item__infobox--label"
    }, [_vm._v(_vm._s(_vm.$lang.global.data_provider) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "item__infobox--content"
    }, _vm._l((result.data_provider), function(data_provider) {
      return _c('span', [_vm._v(_vm._s(data_provider))])
    }))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item__footer"
    }, [_c('div', {
      staticClass: "item__issue-period"
    }, [_vm._v("\n            " + _vm._s(_vm.$lang.global.issue_period) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(result.date_start, "YYYY")) + " - " + _vm._s(_vm._f("moment")(result.date_end, "YYYY")))])]), _vm._v(" "), _c('div', {
      staticClass: "item__count"
    }, [_vm._v("\n            " + _vm._s(_vm.$lang.global.count) + ": "), _c('strong', {
      directives: [{
        name: "thousand-number",
        rawName: "v-thousand-number",
        value: (result.count),
        expression: "result.count"
      }],
      attrs: {
        "lang": _vm.$lang.language
      }
    }, [_vm._v(_vm._s(result.count))])]), _vm._v(" "), _c('div', {
      staticClass: "item__showFBC"
    }, [_c('a', {
      staticClass: "item__showFBC--link",
      attrs: {
        "target": "_blank",
        "href": _vm.fbcSearchQueryPrefix() + _vm.fbcSearchQueryByTitle(result.newspaper_title)
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$lang.global.show_FBC) + " "), _c('i', {
      staticClass: "item__showFBC--icon onp-openwindow"
    })])])])])
  })) : _c('div', {
    staticClass: "noresults"
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.search.results.no_results) + "\n    ")])]), _vm._v(" "), (_vm.searchResultsList.length != 0) ? _c('div', {
    staticClass: "columns columns__bottom"
  }, [_c('div', {
    staticClass: "column--ipp"
  }, [_c('items-per-page')], 1), _vm._v(" "), _c('div', {
    staticClass: "column column--pagination"
  }, [_c('pagination')], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: {
      "is-fixed": _vm.fixed, "has-shadow": _vm.fixed
    }
  }, [_c('div', {
    staticClass: "header__logo"
  }, [_c('a', {
    staticClass: "header__logo--anchor",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "header__logo--image",
    attrs: {
      "src": "static/img/logo.svg",
      "alt": _vm.$lang.altimg.logo,
      "width": "150",
      "height": "65"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header__box"
  }, [(_vm.fixed) ? _c('div', {
    staticClass: "header__box--search header__search"
  }, [_c('search-form')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header__box--font header__font",
    class: {
      'is-active': _vm.isActiveFont, 'is-bigger-font': _vm.isFontSet
    },
    on: {
      "click": _vm.toggleFont
    }
  }, [_c('a', {
    staticClass: "header__font--select",
    attrs: {
      "href": "",
      "title": _vm.$lang.header.font
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('span', {
    staticClass: "onp-font"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header__font--dropdown header__dropdown"
  }, _vm._l((_vm.$lang.fonts.name), function(key, value) {
    return _c('a', {
      staticClass: "header__dropdown--item",
      class: {
        'is-active': _vm.fontSize == value
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setFont(value)
        }
      }
    }, [_c('span', {
      staticClass: "header__font--symbol"
    }, [_vm._v("\n            A\n            "), (value == 'medium') ? _c('sup', [_vm._v("+")]) : _vm._e(), _vm._v(" "), (value == 'big') ? _c('sup', [_vm._v("++")]) : _vm._e()]), _vm._v("\n          " + _vm._s(key) + "\n        ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "header__box--lang header__lang",
    class: {
      'is-active': _vm.isActiveLang
    },
    on: {
      "click": _vm.toggleLang
    }
  }, [_c('a', {
    staticClass: "header__lang--select",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.language.toUpperCase()) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "header__lang--dropdown header__dropdown"
  }, _vm._l((_vm.$langs), function(lang) {
    return _c('a', {
      staticClass: "header__dropdown--item",
      class: {
        'is-active': _vm.isActiveLangClass(lang)
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setLang(lang)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.langs[lang]))])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search-block-main'), _vm._v(" "), _c('div', {
    staticClass: "belt"
  }, [(_vm.searchResultsList.length != 0) ? _c('div', {
    staticClass: "belt__container"
  }, [_c('div', {
    staticClass: "belt__boxes"
  }, [_c('div', {
    staticClass: "belt__box belt__box--left"
  }, [_c('items-per-page'), _vm._v(" "), _c('sort-dropdown')], 1), _vm._v(" "), _c('div', {
    staticClass: "belt__box belt__box--right"
  }, [_c('pagination-with-input')], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search__container"
  }, [_c('div', {
    staticClass: "search__boxes"
  }, [_c('div', {
    staticClass: "search__box search__box--left"
  }, [_c('div', {
    staticClass: "block block--info"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.search.info.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-info')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block block--filters"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-filters')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "search__box search__box--right"
  }, [_c('div', {
    staticClass: "block block--results"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.search.results.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-results')], 1)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-main",
    class: {
      'fixed': _vm.appScroll
    }
  }, [_c('div', {
    staticClass: "search-main__box-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "search-main__header"
  }, [_c('img', {
    staticClass: "header__bg",
    attrs: {
      "src": "static/img/header.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "search-main__desc"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.search.main.desc) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-main__box"
  }, [_vm._m(0), _vm._v(" "), _c('search-form')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-main__form-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/img/newspaper.svg"
    }
  })])
}]}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                Error 404\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n                Not found\n            ")])])])])
}]}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__top"
  }, [_c('ul', {
    staticClass: "footer__list"
  }, _vm._l((_vm.$lang.footer.menu), function(footerLink) {
    return _c('li', {
      staticClass: "footer__list--item"
    }, [_c('a', {
      staticClass: "footer__list--item-link",
      attrs: {
        "href": footerLink.link
      }
    }, [_vm._v(_vm._s(footerLink.title))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "footer__bottom"
  }, [_c('div', {
    staticClass: "footer__bottom--text"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "footer__bottom--span"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.footer.text.first) + "\n          "), _c('a', {
    staticClass: "footer__bottom--link full",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PSNC.full))]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--link short",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PSNC.short))])]), _vm._v(" "), _c('span', {
    staticClass: "footer__bottom--span"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.footer.text.second) + "\n          "), _c('a', {
    staticClass: "footer__bottom--link full",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PIONIER.full))]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--link short",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link
    }
  }, [_vm._v(_vm._s(_vm.$lang.footer.text.PIONIER.short))])])]), _vm._v(" "), _c('p', {
    staticClass: "footer__bottom--partners"
  }, [_c('a', {
    staticClass: "footer__bottom--partners-link",
    attrs: {
      "href": _vm.$lang.footer.text.PSNC.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__pcss.png",
      "title": _vm.$lang.footer.text.PSNC.full
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "footer__bottom--partners-link",
    attrs: {
      "href": _vm.$lang.footer.text.PIONIER.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__pionier.png",
      "title": _vm.$lang.footer.text.PIONIER.full
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "footer__bottom--img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/footer__fbc.svg"
    }
  })])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sort"
  }, [_c('span', {
    staticClass: "sort__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "sort__container--select",
    attrs: {
      "disabled": _vm.loading.state
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortParam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.sortResults($event)
      }]
    }
  }, _vm._l((_vm.$lang.sorting.params), function(param) {
    return _c('option', {
      staticClass: "sort__container--option",
      domProps: {
        "value": param.val
      }
    }, [_vm._v(_vm._s(param.name))])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filters__mobile"
  }, [_c('button', {
    staticClass: "filters__mobile--button",
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.filters.choose))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "filters__box"
  }, [_c('div', {
    staticClass: "filters__box__content",
    class: {
      'filters__box--active': _vm.isActiveFilters
    }
  }, [_c('div', {
    staticClass: "filters__box__close"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleFilters()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.filters.close))])]), _vm._v(" "), _c('div', {
    staticClass: "filters__box__list"
  }, [_c('div', {
    staticClass: "filters__box__title"
  }, [_c('h3', {
    staticClass: "filters__box__header"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.filters.choose) + "\n          ")])]), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--language filter",
    attrs: {
      "name": "language",
      "values": _vm.filtersFields.language
    }
  }), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--data-provider filter",
    attrs: {
      "name": "data_provider",
      "values": _vm.filtersFields.data_provider
    }
  }), _vm._v(" "), _c("search-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--place-of-publishing filter",
    attrs: {
      "name": "place_of_publishing",
      "values": _vm.filtersFields.place_of_publishing
    }
  }), _vm._v(" "), _c("search-date-filter", {
    tag: "div",
    staticClass: "filters__item filters__item--date filter"
  }), _vm._v(" "), _c('div', {
    staticClass: "filters__bottom filters__box__clear"
  }, [(_vm.isFiltersSet || _vm.isDateSet) ? _c('button', {
    staticClass: "filters__bottom--clear",
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.filters.clear_all) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "filters__bottom"
  }, [(_vm.isFiltersSet || _vm.isDateSet) ? _c('button', {
    staticClass: "filters__bottom--clear",
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.clear_all) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter__header--icon"
  }, [_c('i')])
}]}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page"
  }, [_c('app-header', {
    attrs: {
      "fixed": _vm.appScroll
    }
  }), _vm._v(" "), (_vm.loading.error) ? _c('error-503') : _c('div', [_c('main-search')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isAcceptCookies) ? _c('div', {
    staticClass: "cookies"
  }, [_c('div', {
    staticClass: "cookies__inner"
  }, [_c('div', {
    staticClass: "cookies__box"
  }, [_c('button', {
    staticClass: "cookies__box--close",
    on: {
      "click": function($event) {
        _vm.setAcceptCookies()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/cookies__close.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cookies__box--text"
  }, [_vm._v(_vm._s(_vm.$lang.cookies.bar.text))]), _vm._v(" "), _c('a', {
    staticClass: "cookies__box--text cookies__box--link",
    on: {
      "click": function($event) {
        _vm.toggleCookieModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.cookies.bar.link))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActiveCookieModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$lang.cookies.modal.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.toggleCookieModal()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.$lang.cookies.modal.text)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "belt__pagination--nav"
  }, [_c('a', {
    staticClass: "belt__pagination--prev",
    attrs: {
      "href": "",
      "disabled": _vm.isFirstPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.prev_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "belt__pagination--input-container"
  }, [_c('p', [_c('input', {
    staticClass: "belt__pagination--input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.totalPagesNum,
      "placeholder": "Page number",
      "disabled": _vm.loading.state
    },
    domProps: {
      "value": _vm.getCurrentPage
    },
    on: {
      "change": function($event) {
        _vm.updateCurrentPage($event)
      }
    }
  })]), _vm._v(" "), (_vm.appIsRunning) ? _c('p', {
    staticClass: "belt__pagination--max"
  }, [_c('span', {
    staticClass: "belt__pagination--max-from"
  }, [_vm._v(_vm._s(_vm.$lang.pagination.from_pages))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "title": _vm.totalPagesNum
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActivePage(_vm.totalPagesNum)
      }
    }
  }, [_vm._v(_vm._s(_vm.totalPagesNum))])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "belt__pagination--next",
    attrs: {
      "href": "",
      "disabled": _vm.isLastPage() || _vm.loading.state,
      "title": _vm.$lang.pagination.next_page
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "back-to-top-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vue-back-to-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'active': _vm.isOpened
    }
  }, [(_vm.isOpened) ? _c('button', {
    staticClass: "filter__back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setOpened()
      }
    }
  }, [_c('i', {
    staticClass: "daterange__goback--icon"
  }), _vm._v("\n    " + _vm._s(_vm.$lang.filters.back) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter__header"
  }, [_c('button', {
    staticClass: "filter__header--button",
    class: {
      'filter__header--button-active': _vm.isOpened
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.global.date_filter) + "\n      "), _vm._m(0)])]), _vm._v(" "), (_vm.isOpened) ? _c('div', {
    staticClass: "filter__list facet facet--date"
  }, [_c('div', {
    staticClass: "facet__header"
  }, [_c('button', {
    staticClass: "facet__header--close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_c('i')])]), _vm._v(" "), _c('div', {
    staticClass: "facet__date"
  }, [_c('div', {
    staticClass: "facet__date--header date"
  }, [_c('div', {
    staticClass: "date__row"
  }, [_c('div', {
    staticClass: "date__inputs date__inputs--from"
  }, [_c('label', {
    staticClass: "date__inputs--label"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.from))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.dateFrom),
      expression: "dateFrom",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "date__inputs--input",
    class: {
      'date__inputs--input-notvalid': !_vm.isDateCheck
    },
    attrs: {
      "placeholder": "dd.mm.yyyy"
    },
    domProps: {
      "value": (_vm.dateFrom)
    },
    on: {
      "change": [function($event) {
        _vm.dateFrom = $event.target.value
      }, function($event) {
        _vm.setNewRange(_vm.dateFrom, _vm.dateTo, 'from', _vm.start)
      }]
    }
  }), _vm._v(" "), (!_vm.fromValid) ? _c('div', {
    staticClass: "date__inputs--error"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.not_valid))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "date__inputs date__inputs--to"
  }, [_c('label', {
    staticClass: "date__inputs--label"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.to))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.dateTo),
      expression: "dateTo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "date__inputs--input",
    class: {
      'date__inputs--input-notvalid': !_vm.isDateCheck
    },
    attrs: {
      "placeholder": "dd.mm.yyyy"
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "change": [function($event) {
        _vm.dateTo = $event.target.value
      }, function($event) {
        _vm.setNewRange(_vm.dateFrom, _vm.dateTo, 'to', _vm.end)
      }]
    }
  }), _vm._v(" "), (!_vm.toValid) ? _c('div', {
    staticClass: "date__inputs--error"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.not_valid))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "date__info"
  }, [_c('span', {
    staticClass: "date__info--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.placeholder))])])]), _vm._v(" "), _c('div', {
    staticClass: "date__row date__row--submit"
  }, [_c('div', {
    staticClass: "date__count"
  }, [_c('span', {
    staticClass: "date__count--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.date.total_number) + ":")]), _c('span', {
    directives: [{
      name: "thousand-number",
      rawName: "v-thousand-number",
      value: (_vm.dateCount),
      expression: "dateCount"
    }],
    staticClass: "date__count--number",
    attrs: {
      "lang": _vm.$lang.language
    }
  }, [_vm._v(_vm._s(_vm.dateCount))])]), _vm._v(" "), _c('div', {
    staticClass: "date__submit"
  }, [_c('button', {
    staticClass: "date__submit--button",
    attrs: {
      "disabled": _vm.isNewValue || !_vm.fromValid || !_vm.toValid || !_vm.isDateCheck
    },
    on: {
      "click": function($event) {
        _vm.setDateRange()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.filters.submit) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "facet__date--range"
  }, [_c('div', {
    staticClass: "daterange"
  }, [_c('div', {
    staticClass: "daterange__goback"
  }, [(_vm.dateArr.length > 0) ? _c('button', {
    staticClass: "daterange__goback--button",
    on: {
      "click": function($event) {
        _vm.popFromDateArr()
      }
    }
  }, [_c('i', {
    staticClass: "daterange__goback--icon"
  })]) : _vm._e()]), _vm._v(" "), (_vm.dateRanges.length > 1) ? _c('div', {
    staticClass: "daterange__date"
  }, [_c('div', {
    staticClass: "daterange__date--from"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dateRanges[0].start, 'DD.MM.YYYY')))]), _vm._v(" "), _c('div', {
    staticClass: "daterange__date--middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "daterange__date--to"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dateRanges[_vm.dateRanges.length - 1].end, 'DD.MM.YYYY')))])]) : _vm._e(), _vm._v(" "), (_vm.dateRanges.length > 1) ? _c('div', {
    staticClass: "daterange__graph"
  }, [_c('div', {
    staticClass: "daterange__graph--up"
  }), _vm._v(" "), _c('div', {
    staticClass: "daterange__graph--middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "daterange__graph--down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "daterange__list"
  }, _vm._l((_vm.dateRanges), function(date) {
    return _c('li', {
      staticClass: "daterange__list--item"
    }, [_c('button', {
      staticClass: "daterange__item",
      class: {
        'disabled': date.results <= 0 || _vm.dateRanges.length <= 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setNewRange(date.start, date.end)
        }
      }
    }, [_c('div', {
      staticClass: "daterange__item--from"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("moment")(date.start, 'DD.MM.YYYY')) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "daterange__item--hyphen"
    }, [_vm._v("\n                  -\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "daterange__item--to"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("moment")(date.end, 'DD.MM.YYYY')) + "\n                ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "thousand-number",
        rawName: "v-thousand-number",
        value: (date.results),
        expression: "date.results"
      }],
      staticClass: "daterange__item--count",
      attrs: {
        "lang": _vm.$lang.language
      }
    }, [_vm._v("\n                  " + _vm._s(date.results) + "\n                ")]), _vm._v(" "), _vm._m(1, true)])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.isDateSet) ? _c('div', {
    staticClass: "filter__content"
  }, [_c('ul', {
    staticClass: "filter__params"
  }, [_c('li', {
    staticClass: "filter__params--item filter__param"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.date.from) + ": "), _c('span', {
    staticClass: "filter__param--date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.from, 'DD.MM.YYYY')))])]), _vm._v(" "), _c('li', {
    staticClass: "filter__params--item filter__param"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.date.to) + ": "), _c('span', {
    staticClass: "filter__param--date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.to, 'DD.MM.YYYY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "filter__content--bottom"
  }, [(_vm.isDateSet) ? _c('button', {
    staticClass: "filter__params--clear",
    on: {
      "click": function($event) {
        _vm.resetDateRange()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.clear) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isDateSet) ? _c('button', {
    staticClass: "filter__params--add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.add) + "\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter__header--icon"
  }, [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "daterange__item--link"
  }, [_c('i', {
    staticClass: "daterange__item--icon"
  })])
}]}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'active': _vm.isOpened
    }
  }, [(_vm.isOpened) ? _c('button', {
    staticClass: "filter__back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setOpened()
      }
    }
  }, [_c('i', {
    staticClass: "daterange__goback--icon"
  }), _vm._v("\n    " + _vm._s(_vm.$lang.filters.back) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter__header"
  }, [_c('button', {
    staticClass: "filter__header--button",
    class: {
      'filter__header--button-active': _vm.isOpened
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.global[_vm.name]) + "\n      "), _vm._m(0)])]), _vm._v(" "), (_vm.isOpened) ? _c('div', {
    staticClass: "filter__list facet"
  }, [_c('div', {
    staticClass: "facet__header"
  }, [_c('button', {
    staticClass: "facet__header--close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_c('i')])]), _vm._v(" "), _c('div', {
    staticClass: "facet__content"
  }, [_c('div', {
    staticClass: "facet__content--header"
  }, [_c('div', {
    staticClass: "facet__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "facet__search--input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang.filters.search.placeholder
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "facet__search--submit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "facet__addons"
  }, [_c('div', {
    staticClass: "facet__addons--selected facet__selected"
  }, [_c('button', {
    staticClass: "facet__selected--button",
    class: {
      'facet__selected--button-active': _vm.checkedFiltersTmp.length != _vm.filteredListTmp.length
    },
    on: {
      "click": function($event) {
        _vm.selectAll()
      }
    }
  }, [_c('span', {
    staticClass: "facet__selected--checkbox"
  }, [_c('i', {
    staticClass: "facet__selected--icon facet__selected--icon-select"
  }, [_c('svg', {
    staticClass: "input-box-tick",
    attrs: {
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M1.7,7.8l3.8,3.4l9-8.8"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "facet__selected--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.select_all))])]), _vm._v(" "), _c('button', {
    staticClass: "facet__selected--button",
    class: {
      'facet__selected--button-active': _vm.checkedFiltersTmp.length > 0
    },
    on: {
      "click": function($event) {
        _vm.unSelectAll()
      }
    }
  }, [_c('span', {
    staticClass: "facet__selected--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.deselect_all))])])]), _vm._v(" "), (_vm.totalPagesNum > 1) ? _c('div', {
    staticClass: "facet__addons--pagination"
  }, [_c('div', {
    staticClass: "facet__pagination"
  }, [_c('button', {
    class: [{
      'disabled': _vm.currentPage == 1
    }, 'facet__pagination--prev'],
    on: {
      "click": function($event) {
        _vm.setPrevPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-left"
  })]), _vm._v(" "), _c('input', {
    staticClass: "facet__pagination--input",
    attrs: {
      "disabled": _vm.totalPagesNum == 1,
      "min": "1",
      "max": _vm.totalPagesNum,
      "type": "text",
      "placeholder": _vm.currentPage
    },
    domProps: {
      "value": _vm.currentPage
    },
    on: {
      "change": function($event) {
        _vm.updateCurrentPage($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "facet__pagination--text"
  }, [_vm._v(_vm._s(_vm.$lang.pagination.from_pages) + " "), _c('strong', [_vm._v(_vm._s(_vm.totalPagesNum))])]), _vm._v(" "), _c('button', {
    class: [{
      'disabled': _vm.currentPage == _vm.totalPagesNum
    }, 'facet__pagination--next'],
    on: {
      "click": function($event) {
        _vm.setNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "onp-chevron-right"
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "facet__content--list"
  }, [(_vm.filteredList.length) ? _c('ul', {
    staticClass: "facet__list"
  }, _vm._l((_vm.filteredList), function(subFilter) {
    return _c('li', {
      staticClass: "facet__list--item"
    }, [_c('label', {
      staticClass: "facet__list--label"
    }, [_c('span', {
      staticClass: "facet__list--checkbox"
    }, [_c('checkbox', {
      attrs: {
        "value": subFilter.name
      },
      model: {
        value: (_vm.checkedFiltersTmp),
        callback: function($$v) {
          _vm.checkedFiltersTmp = $$v
        },
        expression: "checkedFiltersTmp"
      }
    })], 1), _vm._v(" "), (_vm.name === 'language') ? _c('span', {
      staticClass: "facet__list--name"
    }, [_c('check-lang-code', {
      attrs: {
        "langCode": subFilter.name
      }
    })], 1) : _c('span', {
      staticClass: "facet__list--name"
    }, [_vm._v(_vm._s(subFilter.name))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "thousand-number",
        rawName: "v-thousand-number",
        value: (subFilter.results),
        expression: "subFilter.results"
      }],
      staticClass: "facet__list--count",
      attrs: {
        "lang": _vm.$lang.language
      }
    }, [_vm._v(_vm._s(subFilter.results))])])])
  })) : _c('div', {
    staticClass: "facet__emptylist"
  }, [_vm._v(_vm._s(_vm.$lang.filters.emptylist))])]), _vm._v(" "), _c('div', {
    staticClass: "facet__content--footer facet__submit"
  }, [_c('button', {
    staticClass: "facet__submit--button",
    attrs: {
      "disabled": _vm.activeSubmit
    },
    on: {
      "click": function($event) {
        _vm.setFilters()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.filters.submit) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.filterParam) ? _c('div', {
    staticClass: "filter__content"
  }, [_c('ul', {
    staticClass: "filter__params"
  }, _vm._l((_vm.filterParam.filters), function(filter) {
    return _c('li', {
      staticClass: "filter__params--item filter__param"
    }, [(_vm.name === 'language') ? _c('span', {
      staticClass: "filter__param--name"
    }, [_c('check-lang-code', {
      attrs: {
        "langCode": filter
      }
    })], 1) : _c('span', {
      staticClass: "filter__param--name",
      attrs: {
        "title": filter
      }
    }, [_vm._v(_vm._s(filter))]), _vm._v(" "), _c('button', {
      staticClass: "filter__param--close",
      on: {
        "click": function($event) {
          _vm.deleteFilter(filter)
        }
      }
    }, [_c('i')])])
  })), _vm._v(" "), _c('div', {
    staticClass: "filter__content--bottom"
  }, [(_vm.filterParam.filters) ? _c('button', {
    staticClass: "filter__params--clear",
    on: {
      "click": function($event) {
        _vm.resetFilters()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.clear) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.filterParam.filters) ? _c('button', {
    staticClass: "filter__params--add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpened()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.filters.add) + "\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter__header--icon"
  }, [_c('i')])
}]}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: {
      'font-big': _vm.fontSize == 'big', 'font-medium': _vm.fontSize == 'medium', 'is-fixed': _vm.isFiltersOpened && _vm.isMobile
    },
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('cookies'), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "text": "Back to top",
      "visibleOffset": "200",
      "title": _vm.$lang.go_top
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                Error 503\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n                Service Unavailable\n            ")])])])])
}]}

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports) {

module.exports = {
	"solr": {
		"paths": {
			"API": "http://loheria.man.poznan.pl/"
		},
		"query": {
			"searchPre": "search?",
			"searchPost": "&wt=json"
		},
		"filters": {
			"facet_fileds": [
				"language",
				"data_provider",
				"place_of_publishing"
			],
			"facet_limit": "-1",
			"facet_on": "on",
			"facet_sort_count": "count",
			"facet_mincount": "1",
			"facet_range": "date",
			"facet_date_gap": "1"
		}
	},
	"FBC": {
		"path": "https://fbc.pionier.net.pl",
		"query": {
			"prefix": "/search#",
			"titleFilter": "q=tech_newspaperTitle:",
			"placeFilter": "placeOfPublishing:",
			"fqPrefix": "fq=",
			"dateFilter": "date:",
			"languageFilter": "{!tag=dc_language}",
			"languageFilters": "dc_language:",
			"dataProviderFilter": "{!tag=europeana_dataProvider}",
			"dataProviderFilters": "europeana_dataProvider:",
			"sortBy": "&sort=single_date asc,single_dc_title asc"
		}
	},
	"params": {
		"search": {
			"default": {
				"key": "*:*",
				"param": "",
				"start": 0,
				"pageStart": 1,
				"itemsPerPage": 30,
				"sortOption": "",
				"sortOptionAll": "newspaper_title%20asc"
			}
		}
	},
	"errorsUrl": {
		"error404": "/static/errors/HTTP404.html",
		"error503": "/static/errors/HTTP503.html"
	},
	"brokenImgUrl": "/static/img/owl_text.svg"
};

/***/ }),
/* 353 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[249]);


// WEBPACK FOOTER //
// static/js/app.3e7c4114b8e32a820c8d.js